import type { Catalogue } from "../i18n";

export const ES: Catalogue = {
  "failed": "falló",
  "saving": "guardando",
  "waiting": "en espera",
  "today": "hoy",
  "yesterday": "ayer",
  "{days}d": "{days} d",
  "{weeks}w": "{weeks} sem",
  "unlabeled": "sin nombre",
  "untagged": "sin etiquetas",
  "loading more": "cargando más",
  "that's all {count}": "son todos, {count}",
  "shuffled": "mezclado",
  "nothing to show": "nada que mostrar",
  "chi is looking again": "chi vuelve a mirar",
  "chi is looking at this one next": "chi mirará esta a continuación",
  "could not index that ref": "no se pudo indexar esa ref",
  "details": "detalles",
  "clips are not described, write your own": "los clips no se describen, escribe la tuya",
  "chi left this one ({reason}), write your own": "chi dejó esta ({reason}), escribe la tuya",
  "chi is looking at this…": "chi está mirando esto…",
  "not described yet, write your own or tap spark": "aún sin descripción, escribe la tuya o toca la chispa",
  "saved": "guardado",
  "could not save the description": "no se pudo guardar la descripción",
  "chi skips clips": "chi se salta los clips",
  "described": "descrita",
  "chi is looking": "chi está mirando",
  "skipped": "saltada",
  "waiting on chi": "esperando a chi",
  "tagging {done}/{total} · {left} left": "etiquetando {done}/{total} · quedan {left}",
  "tagged {done}/{total} · {left} left": "etiquetadas {done}/{total} · quedan {left}",
  "all {total} tagged": "las {total} etiquetadas",
  "{shown} of {total}": "{shown} de {total}",
  "{count} adding": "{count} añadiéndose",
  "{count} failed": "{count} fallidas",
  "{count} to describe": "{count} por describir",
  "busy": "ocupada",
  "tag": "etiqueta",
  "tap + to add pictures, drop files here, or use + ref in chrome": "toca + para añadir imágenes, suelta archivos aquí o usa + ref en chrome",
  "every ref already has your note": "todas las refs ya tienen tu nota",
  "nothing matches": "nada coincide",
  "could not load references": "no se pudieron cargar las referencias",
  "video": "vídeo",
  "all described": "todo descrito",
  "could not read that file": "no se pudo leer ese archivo",
  "nothing usable there": "no hay nada utilizable",
  "adding {count}": "añadiendo {count}",
  "could not import that file": "no se pudo importar ese archivo",
  "showing {tag}": "mostrando {tag}",
  "chi is tagging {count} refs": "chi está etiquetando {count} refs",
  "every ref is tagged": "todas las refs están etiquetadas",
  "could not start tagging": "no se pudo empezar a etiquetar",
  "delete this reference?": "¿borrar esta referencia?",
  "ref saved": "ref guardada",
  "ref save failed": "no se pudo guardar la ref",
  "tagging done": "etiquetado terminado",
  "mode": "modo",
  "tools": "herramientas",
  "Tools": "Herramientas",
  "Talk to Chi": "Hablar con Chi",
  "mode tuner, drag or tap a station": "sintonizador de modo, arrastra o toca una emisora",
  "Tool": "Herramienta",
  "Chi · direct line": "Chi · línea directa",
  "{name}'s {what} · read only": "{what} de {name} · solo lectura",
  "could not open a print sheet": "no se pudo abrir una hoja de impresión",
  "never": "nunca",
  "could not shrink that picture": "no se pudo reducir esa imagen",
  "could not read that picture": "no se pudo leer esa imagen",
  "chix is processing": "chix está procesando",
  "What should I work on next?": "¿En qué debería trabajar ahora?",
  "nothing yet": "aún nada",
  "where it came from": "de dónde vino",
  "rent, phone…": "alquiler, teléfono…",
  "what was it": "qué fue",
  "mine": "el mío",
  "{name}'s": "de {name}",
  "added to {name}'s budget": "añadido al presupuesto de {name}",
  "added to your budget": "añadido a tu presupuesto",
  "couldn't add that": "no se pudo añadir",
  "login with discord": "entra con discord",
  "minipi #{id}": "minipi n.º {id}",
  "a minipi": "un minipi",
  "{who} says": "{who} dice",
  "{who} · art tip": "{who} · consejo de arte",
  "pings": "avisos",
  "Late shift, {name}.": "Turno de noche, {name}.",
  "Morning, {name}.": "Buenos días, {name}.",
  "Ready when you are, {name}.": "Lista cuando quieras, {name}.",
  "Evening, {name}.": "Buenas tardes, {name}.",
  "signal": "señal",
  "sweet": "dulce",
  "edge": "filo",
  "dark fog, film grain and chi's cyan": "niebla oscura, grano de película y el cian de chi",
  "pale daytime fog, ink and deep teal": "niebla pálida de día, tinta y verde azulado profundo",
  "silent hill ash and an orange coal": "ceniza de silent hill y una brasa naranja",
  "deep water, teal fog, a sonar ping": "agua profunda, niebla verde azulada, un ping de sonar",
  "rose paper and a hot pink signal": "papel rosa y una señal rosa intenso",
  "peach cream and a coral signal": "crema de melocotón y una señal coral",
  "mint milk with strawberry pink": "leche de menta con rosa fresa",
  "magical girl night, violet fog, bubblegum pink": "noche de chica mágica, niebla violeta, rosa chicle",
  "midnight sky in periwinkle and pink": "cielo de medianoche en azul lavanda y rosa",
  "the otherworld: rust black and blood red": "el otro mundo: negro óxido y rojo sangre",
  "night city chrome, warning yellow, red glitch": "cromo de ciudad nocturna, amarillo de alerta, glitch rojo",
  "bruise purple fog and acid lime": "niebla morado moratón y lima ácida",
  "pure black and white, no mercy": "blanco y negro puro, sin piedad",
  "green crt, memory card manager at 2am": "crt verde, gestor de memory card a las 2am",
  "amber crt terminal, warm glow": "terminal crt ámbar, brillo cálido",
  "cream sketch paper and flipnote orange": "papel de boceto crema y naranja flipnote",
  "grey console, blue memory card screen": "consola gris, pantalla azul de memory card",
  "four shades of handheld green": "cuatro tonos de verde portátil",
  "none": "ninguno",
  "scanlines": "líneas de escaneo",
  "grid": "cuadrícula",
  "dots": "puntos",
  "notebook": "cuaderno",
  "checker": "cuadros",
  "crosshair": "mira",
  "sparkles": "destellos",
  "hazard": "peligro",
  "starry sky": "cielo estrellado",
  "falling leaves": "hojas cayendo",
  "sakura petals": "pétalos de sakura",
  "snow": "nieve",
  "rain": "lluvia",
  "fireflies": "luciérnagas",
  "moves gently, stays still with calm motion": "se mueve suave, se queda quieto con movimiento suave",
  "pattern on": "patrón activado",
  "theme on": "tema activado",
  "bottom": "abajo",
  "top": "arriba",
  "one clipped corner, the original look": "una esquina cortada, el look original",
  "square corners everywhere": "esquinas cuadradas en todas partes",
  "gently rounded": "suavemente redondeado",
  "very round, like a handheld menu": "muy redondo, como un menú de consola portátil",
  "the original: Rajdhani titles, pixel labels": "el original: títulos Rajdhani, etiquetas de píxeles",
  "your device's own system font": "la fuente del sistema de tu dispositivo",
  "easy to read": "fácil de leer",
  "Atkinson Hyperlegible, made for low vision": "Atkinson Hyperlegible, hecha para baja visión",
  "dyslexia friendly": "apta para dislexia",
  "OpenDyslexic, weighted letter bottoms": "OpenDyslexic, base de las letras más pesada",
  "rounded": "redondeada",
  "Fredoka, soft and friendly": "Fredoka, suave y amigable",
  "serif": "serif",
  "Lora titles and text": "títulos y texto en Lora",
  "mono": "mono",
  "Space Mono everywhere": "Space Mono en todas partes",
  "typewriter": "máquina de escribir",
  "Special Elite, inky and uneven": "Special Elite, entintada e irregular",
  "Caveat titles, Patrick Hand text": "títulos en Caveat, texto en Patrick Hand",
  "DotGothic16, a psx menu face": "DotGothic16, una fuente de menú psx",
  "VT323, a green screen console": "VT323, una consola de pantalla verde",
  "arcade": "arcade",
  "Press Start 2P titles, pixel text": "títulos en Press Start 2P, texto de píxeles",
  "sci-fi": "ciencia ficción",
  "Orbitron titles over the original labels": "títulos en Orbitron sobre las etiquetas originales",
  "panels you can see through, with a blur": "paneles transparentes, con desenfoque",
  "half see through": "medio transparente",
  "whatever the theme does": "lo que haga el tema",
  "fully opaque, easiest to read over a pattern": "totalmente opaco, lo más fácil de leer sobre un patrón",
  "about 820 px of content": "unos 820 px de contenido",
  "about 1040 px of content": "unos 1040 px de contenido",
  "about 1360 px of content": "unos 1360 px de contenido",
  "use the whole screen": "usa toda la pantalla",
  "centred": "centrado",
  "content in the middle of the screen": "contenido en el centro de la pantalla",
  "content next to the menu, spare room on the right": "contenido junto al menú, espacio libre a la derecha",
  "compact": "compacto",
  "tighter gaps, more on screen": "huecos más pequeños, más cosas en pantalla",
  "the original spacing": "el espaciado original",
  "roomy": "espacioso",
  "extra air around everything": "aire extra alrededor de todo",
  "pages sharpen into view": "las páginas se enfocan poco a poco",
  "a plain fade": "un simple fundido",
  "pages rise into place": "las páginas suben a su sitio",
  "pages simply appear": "las páginas simplemente aparecen",
  "barely there outlines": "contornos casi invisibles",
  "the original": "el original",
  "stronger outlines": "contornos más marcados",
  "menu on the left": "menú a la izquierda",
  "menu on the right": "menú a la derecha",
  "radio dock at the bottom of the screen": "barra de radio en la parte inferior de la pantalla",
  "radio dock at the top of the screen": "barra de radio en la parte superior de la pantalla",
  "brighter text and stronger lines everywhere": "texto más brillante y líneas más marcadas en todas partes",
  "a thick ring on whatever the keyboard has selected": "un anillo grueso sobre lo que el teclado tenga seleccionado",
  "loose": "amplio",
  "more space between letters, words and lines": "más espacio entre letras, palabras y líneas",
  "moving speckle over everything": "motas en movimiento sobre todo",
  "the slow drifting haze behind the pages": "la bruma que flota despacio detrás de las páginas",
  "pattern strength": "intensidad del patrón",
  "how strong the background pattern is, needs a pattern": "qué tan fuerte es el patrón de fondo, necesita un patrón",
  "dark edges of the screen": "bordes oscuros de la pantalla",
  "makes everything bigger or smaller at once": "hace todo más grande o más pequeño a la vez",
  "easy reading": "lectura fácil",
  "big, clear text and strong contrast": "texto grande y claro, con mucho contraste",
  "cream paper, OpenDyslexic, calm": "papel crema, OpenDyslexic, tranquilo",
  "feel and access": "sensación y accesibilidad",
  "contrast": "contraste",
  "spacing": "espaciado",
  "button": "botón",
  "put back": "restaurado",
  "one tap sets the theme, pattern and the look below. yours only, it saves as you": "un toque cambia el tema, el patrón y el look de abajo. solo tuyo, se guarda a tu nombre",
  "reset everything": "restablecer todo",
  "put the whole look back to chi signal?": "¿volver a poner todo el look en chi signal?",
  "back to chi signal": "de vuelta a chi signal",
  "nothing saved yet. set things up the way you like, name it and save it here": "aún no hay nada guardado. déjalo a tu gusto, ponle nombre y guárdalo aquí",
  "look deleted": "look eliminado",
  "your colours": "tus colores",
  "the colour of highlights, selected buttons and the glow. it sits on top of any theme": "el color de los resaltes, los botones seleccionados y el brillo. va sobre cualquier tema",
  "background colour": "color de fondo",
  "your own screen colour instead of the theme's. text and contrast follow on their own": "tu propio color de pantalla en lugar del del tema. el texto y el contraste se ajustan solos",
  "switch themes by itself when this device goes light or dark": "cambia de tema solo cuando este dispositivo pasa a claro u oscuro",
  "off keeps the theme you pick above all day": "apagado, se mantiene todo el día el tema que elijas arriba",
  "in light mode": "en modo claro",
  "in dark mode": "en modo oscuro",
  "how panels, buttons and cards are shaped": "la forma de los paneles, botones y tarjetas",
  "the typeface for titles, labels and text. every one is bundled, nothing is downloaded from outside": "la tipografía de títulos, etiquetas y texto. todas vienen incluidas, no se descarga nada de fuera",
  "panel glass": "cristal de los paneles",
  "how see-through panels are over the background": "qué tan transparentes son los paneles sobre el fondo",
  "outlines": "contornos",
  "how strong the thin lines around things are": "qué tan marcadas son las líneas finas alrededor de las cosas",
  "off writes labels in normal lower case, easier to read": "apagado, las etiquetas se escriben en minúsculas normales, más fáciles de leer",
  "background effects": "efectos de fondo",
  "film grain and fog are switched off on this device, so those two sliders have nothing to move": "el grano de película y la niebla están apagados en este dispositivo, así que esos dos deslizadores no mueven nada",
  "turn them on": "activarlos",
  "grain and fog on": "grano y niebla activados",
  "off on this device, turn it on above": "apagado en este dispositivo, actívalo arriba",
  "pick a pattern above and this will change how strong it is": "elige un patrón arriba y esto cambiará su intensidad",
  "grain and fog on this device": "grano y niebla en este dispositivo",
  "this switch is for this browser only. use it to calm a busy screen or a slow device": "este interruptor es solo para este navegador. úsalo para calmar una pantalla recargada o un dispositivo lento",
  "how wide the page content gets. it only shows on screens wider than the setting, so on a phone nothing changes": "qué tan ancho es el contenido de la página. solo se nota en pantallas más anchas que el ajuste, así que en el móvil no cambia nada",
  "page position": "posición de la página",
  "where the content sits on wide screens": "dónde se coloca el contenido en pantallas anchas",
  "how close or far apart things sit": "qué tan juntas o separadas están las cosas",
  "menu side, tablets and computers": "lado del menú, tabletas y ordenadores",
  "which side the menu with the dial sits on, on screens wider than 900 px": "en qué lado está el menú con el dial, en pantallas de más de 900 px",
  "dock position, phones": "posición de la barra, móviles",
  "where the radio dock sits on phones and portrait tablets": "dónde está la barra de radio en móviles y tabletas en vertical",
  "the motion as you switch pages": "el movimiento al cambiar de página",
  "size and comfort": "tamaño y comodidad",
  "brighter text and stronger lines": "texto más brillante y líneas más marcadas",
  "keyboard focus ring": "anillo de foco del teclado",
  "how clearly the selected control is marked when you use the keyboard": "qué tan claro se marca el control seleccionado al usar el teclado",
  "text spacing": "espaciado del texto",
  "more room between letters, words and lines, kinder on tired eyes": "más espacio entre letras, palabras y líneas, más amable con los ojos cansados",
  "turn off the quick flicker when a page opens": "apaga el parpadeo rápido al abrir una página",
  "stops the fog, falling pieces and most movement on this device": "detiene la niebla, las piezas que caen y casi todo el movimiento en este dispositivo",
  "this device only": "solo este dispositivo",
  "a short beep when you press a button, like a console menu": "un pitido corto al pulsar un botón, como en el menú de una consola",
  "sounds off": "sonidos apagados",
  "sounds on": "sonidos activados",
  "tap effect": "efecto al tocar",
  "what appears where you touch the screen": "lo que aparece donde tocas la pantalla",
  "tap effect off": "efecto al tocar apagado",
  "tap effect on": "efecto al tocar activado",
  "put this page back": "restablecer esta página",
  "chip": "etiqueta",
  "preview": "vista previa",
  "the quick brown fox jumps over the lazy dog": "el veloz murciélago hindú comía feliz cardillo y kiwi",
  "look settings": "ajustes del look",
  "a faint pattern behind the pages. the animated ones stay still with calm motion": "un patrón tenue detrás de las páginas. los animados se quedan quietos con el movimiento calmado",
  "left side": "lado izquierdo",
  "right side": "lado derecho",
  "one tap sets the theme, pattern and everything below. yours only, it saves as you": "un toque ajusta el tema, el patrón y todo lo de abajo. solo tuyo, se guarda a tu nombre",
  "your looks": "tus aspectos",
  "delete this look?": "¿borrar este aspecto?",
  "delete this look": "borrar este aspecto",
  "name this look": "ponle nombre a este aspecto",
  "save current look": "guardar el aspecto actual",
  "surprise me": "sorpréndeme",
  "reset look": "restablecer aspecto",
  "put the look back to chi signal?": "¿volver al aspecto chi signal?",
  "my look": "mi aspecto",
  "look code": "código de aspecto",
  "copy my code": "copiar mi código",
  "use this code": "usar este código",
  "button sounds": "sonidos de botones",
  "where you tap": "donde tocas",
  "the theme's own": "la del tema",
  "pick any colour": "elige cualquier color",
  "that is the most looks you can keep, delete one first": "es el máximo de aspectos que puedes guardar, borra uno primero",
  "look saved": "aspecto guardado",
  "share a look": "compartir un aspecto",
  "copy your code and send it to anyone. paste theirs here and press use to wear it": "copia tu código y envíalo a quien quieras. pega el suyo aquí y pulsa usar para ponértelo",
  "code copied": "código copiado",
  "code selected, copy it by hand": "código seleccionado, cópialo a mano",
  "that is not a look code": "eso no es un código de aspecto",
  "look on": "aspecto activado",
  "rolled a new look": "nuevo aspecto al azar",
  "look reset": "aspecto restablecido",
  "this device": "este dispositivo",
  "sound and taps are kept on this browser only, grain and calm motion are above": "el sonido y los toques se guardan solo en este navegador, el grano y el movimiento calmado están arriba",
  "colours": "colores",
  "an accent over any theme, and an optional background of your own. text and tone follow on their own": "un acento sobre cualquier tema y, si quieres, un fondo propio. el texto y el tono se ajustan solos",
  "shape and type": "forma y tipografía",
  "accent": "acento",
  "corners": "esquinas",
  "font": "fuente",
  "panels": "paneles",
  "capital letters on labels": "mayúsculas en las etiquetas",
  "atmosphere": "ambiente",
  "how much fog, grain and pattern sit behind everything. grain and fog also need the switch below": "cuánta niebla, grano y patrón hay detrás de todo. el grano y la niebla también necesitan el interruptor de abajo",
  "layout and motion": "diseño y movimiento",
  "page width": "ancho de página",
  "rail side, on tablets and desktops": "lado del riel, en tablets y escritorio",
  "when a page opens": "al abrir una página",
  "station worlds": "estaciones con mundo propio",
  "each station gets its own colour, moving backdrop and a title that locks in when a page opens": "cada estación tiene su color, un fondo en movimiento y un título que se fija al abrir una página",
  "tilt and magnetic": "inclinar e imán",
  "tiles lean toward your finger or pointer and main buttons pull toward the cursor": "las tarjetas se inclinan hacia tu dedo o puntero y los botones principales se acercan al cursor",
  "glitch on page titles": "glitch en los títulos de página",
  "day and night": "día y noche",
  "switch themes with this device's light or dark setting": "cambiar de tema según el modo claro u oscuro de este dispositivo",
  "follow the device": "seguir el dispositivo",
  "light mode": "modo claro",
  "dark mode": "modo oscuro",
  "cut": "cortada",
  "sharp": "afilada",
  "round": "redonda",
  "clean": "limpia",
  "pixel": "píxel",
  "handwritten": "manuscrita",
  "clear glass": "vidrio claro",
  "frosted": "esmerilado",
  "theme": "tema",
  "solid": "sólido",
  "narrow": "estrecho",
  "normal": "normal",
  "full": "completo",
  "blur in": "entrar desenfocado",
  "fade": "desvanecer",
  "slide up": "deslizar hacia arriba",
  "faint": "tenues",
  "bold": "marcadas",
  "right": "derecha",
  "film grain": "grano de película",
  "pattern": "patrón",
  "vignette": "viñeta",
  "interface size": "tamaño de la interfaz",
  "blip": "bip",
  "click": "clic",
  "ripple": "ondas",
  "spark": "chispa",
  "chi signal": "chi signal",
  "the original, untouched": "el original, intacto",
  "silent hill": "silent hill",
  "ember, heavy fog and grain": "brasa, niebla densa y grano",
  "flipnote": "flipnote",
  "sketch paper, handwriting, soft corners": "papel de boceto, letra a mano, esquinas suaves",
  "memory card": "tarjeta de memoria",
  "psx grey, pixel type, sharp": "gris psx, letra de píxeles, afilado",
  "magical girl": "magical girl",
  "lilac night, sparkles, round": "noche lila, destellos, redondo",
  "dsi menu": "menú dsi",
  "glossy white, rounded, clean": "blanco brillante, redondeado, limpio",
  "terminal": "terminal",
  "green crt, monospace, no frills": "crt verde, monoespaciada, sin florituras",
  "the rain": "la lluvia",
  "code rain on black": "lluvia de código sobre negro",
  "night city": "ciudad nocturna",
  "warning yellow, hazard stripes": "amarillo de aviso, franjas de peligro",
  "cozy afternoon": "tarde acogedora",
  "peach cream and falling petals": "crema de durazno y pétalos cayendo",
  "midnight forest": "bosque de medianoche",
  "moss and fireflies": "musgo y luciérnagas",
  "mall soft": "mall suave",
  "vapor pink and cyan edge": "rosa vapor y borde cian",
  "drafting table": "mesa de dibujo",
  "blueprint, grid and mono": "plano azul, cuadrícula y monoespaciada",
  "blue screen": "pantalla azul",
  "a very polite crash": "un cierre muy educado",
  "deep sea": "mar profundo",
  "abyss and slow bubbles": "abismo y burbujas lentas",
  "quiet paper": "papel tranquilo",
  "light, calm, no effects": "claro, calmado, sin efectos",
  "nature": "naturaleza",
  "sunset": "atardecer",
  "dusk violet and a burnt orange sun": "violeta del anochecer y un sol naranja tostado",
  "forest": "bosque",
  "moss, wet bark and leaf green": "musgo, corteza húmeda y verde hoja",
  "coffee": "café",
  "espresso brown and crema": "marrón espresso y crema",
  "ice": "hielo",
  "frozen pale blue and deep water ink": "azul pálido helado y tinta de agua profunda",
  "matcha": "matcha",
  "soft green tea and a dark leaf": "té verde suave y una hoja oscura",
  "vapor": "vapor",
  "late night mall, pink on purple with a cyan edge": "centro comercial de madrugada, rosa sobre morado con borde cian",
  "bsod": "bsod",
  "a blue screen, white text, nothing to hide": "una pantalla azul, texto blanco, nada que esconder",
  "blueprint": "plano azul",
  "cyan ink on drafting blue": "tinta cian sobre azul de dibujo",
  "dsi": "dsi",
  "glossy white handheld and its blue menu": "portátil blanca brillante y su menú azul",
  "waves": "olas",
  "honeycomb": "panal",
  "diamonds": "rombos",
  "cross stitch": "punto de cruz",
  "embers": "brasas",
  "bubbles": "burbujas",
  "code rain": "lluvia de código",
  "saved, type to replace": "guardada, escribe para reemplazar",
  "not set": "sin configurar",
  "token copied": "token copiado",
  "make a new extension token? the old one stops working until you paste the new one in": "¿crear un nuevo token de extensión? el viejo deja de funcionar hasta que pegues el nuevo",
  "new token made": "nuevo token creado",
  "log out of chix on every device?": "¿cerrar sesión de chix en todos los dispositivos?",
  "$ dollar": "$ dólar",
  "£ pound": "£ libra",
  "C$ canadian": "C$ canadiense",
  "A$ australian": "A$ australiano",
  "CHF swiss franc": "CHF franco suizo",
  "talking to plane": "hablando con plane",
  "connected to {workspace}, now pick your boards": "conectado a {workspace}, ahora elige tus tableros",
  "open plane": "abrir plane",
  "in safari, create an api token in profile settings, paste it below, then save": "en safari, crea un token de api en ajustes del perfil, pégalo abajo y guarda",
  "couldn't do that": "no se pudo hacer",
  "google turned the map key away. check it's allowed on this site and maps javascript api is on": "google rechazó la clave del mapa. revisa que esté permitida en este sitio y que maps javascript api esté activada",
  "the map needs a key to draw, searches and routes still work below": "el mapa necesita una clave para dibujarse, las búsquedas y rutas siguen funcionando abajo",
  "the map couldn't load. searches and routes still work below": "el mapa no pudo cargar. las búsquedas y rutas siguen funcionando abajo",
  "you": "tú",
  "new pin": "nuevo pin",
  "open now": "abierto ahora",
  "closed now": "cerrado ahora",
  "new": "nuevo",
  "{rating} from 1 review": "{rating} de 1 reseña",
  "{rating} from {count} reviews": "{rating} de {count} reseñas",
  "no reviews yet": "aún no hay reseñas",
  "no parking info": "sin info de aparcamiento",
  "no parking listed": "no hay aparcamiento indicado",
  "{place} is stop {letter}": "{place} es la parada {letter}",
  "save": "guardar",
  "looking…": "buscando…",
  "nothing found there. try further out or other words": "no se encontró nada ahí. prueba más lejos u otras palabras",
  "pick something to look for, or search above": "elige algo que buscar o busca arriba",
  "{what} within {distance} of {place}": "{what} a menos de {distance} de {place}",
  "around {place}": "cerca de {place}",
  "ten stops is the most": "diez paradas es el máximo",
  "taken out of saved": "quitado de guardados",
  "remove {name}?": "¿quitar {name}?",
  "nothing saved yet": "aún no hay nada guardado",
  "tap the map": "toca el mapa",
  "drop a pin": "poner un pin",
  "edit {name}": "editar {name}",
  "save pin": "guardar pin",
  "my pin": "mi pin",
  "pinned": "fijado",
  "places, ratings, parking and routes come from google maps. it needs a key from your google cloud account, google gives a free allowance each month": "los lugares, valoraciones, aparcamiento y rutas vienen de google maps. necesita una clave de tu cuenta de google cloud, google da un uso gratis cada mes",
  "fractal hasn't added a google maps key yet, so the map can't look anything up": "fractal aún no ha añadido una clave de google maps, así que el mapa no puede buscar nada",
  "within {distance}": "a menos de {distance}",
  "this area": "esta zona",
  "couldn't find where you are, staying around {place}": "no se pudo encontrar dónde estás, sigo cerca de {place}",
  "cyan": "cian",
  "violet": "violeta",
  "amber": "ámbar",
  "green": "verde",
  "red": "rojo",
  "tap the map where the pin goes": "toca el mapa donde va el pin",
  "couldn't find where you are": "no se pudo encontrar dónde estás",
  "take this pin off the map?": "¿quitar este pin del mapa?",
  "where i am": "donde estoy",
  "home ({place})": "casa ({place})",
  "name this route": "ponle nombre a esta ruta",
  "{from} to {to}": "{from} a {to}",
  "route saved": "ruta guardada",
  "food": "comida",
  "pubs and bars": "pubs y bares",
  "takeaway": "para llevar",
  "shops": "tiendas",
  "fuel": "gasolina",
  "parking": "aparcamiento",
  "pharmacy": "farmacia",
  "parks": "parques",
  "things to see": "cosas que ver",
  "cinema": "cine",
  "ev charging": "carga de coches eléctricos",
  "drive": "coche",
  "walk": "a pie",
  "cycle": "bici",
  "bus/train": "bus/tren",
  "{amount} a month": "{amount} al mes",
  "by {date}": "para el {date}",
  "monthly, stopped {date}": "mensual, parado el {date}",
  "monthly from {date}": "mensual desde {date}",
  "on {date}": "el {date}",
  "added by you": "añadido por ti",
  "added by {name}": "añadido por {name}",
  "{done} paid of {total} · {left} left": "{done} pagado de {total} · quedan {left}",
  "paid off · {total}": "pagado del todo · {total}",
  "{done} saved of {total} · {left} to go": "{done} ahorrado de {total} · faltan {left}",
  "reached · {done}": "logrado · {done}",
  "in": "entrada",
  "bill": "factura",
  "cost": "gasto",
  "debt": "deuda",
  "goal": "meta",
  "remove {name}? its history goes too": "¿quitar {name}? su historial también se va",
  "restart": "reiniciar",
  "stop": "parar",
  "paid": "pagado",
  "payment logged": "pago anotado",
  "saved toward it": "ahorrado para ello",
  "took back the last one": "se deshizo el último",
  "{amount} left": "quedan {amount}",
  "{amount} saved": "{amount} ahorrado",
  "out": "salidas",
  "no monthly bills yet": "aún no hay facturas mensuales",
  "owe": "debo",
  "{percent}% of {total}": "{percent}% de {total}",
  "{amount} this month": "{amount} este mes",
  "owed in total": "debido en total",
  "target": "objetivo",
  "a month (optional)": "al mes (opcional)",
  "how much comes in": "cuánto entra",
  "how much": "cuánto",
  "by": "para el",
  "since": "desde",
  "from": "desde",
  "on": "el",
  "where it comes from": "de dónde viene",
  "rent, phone, adobe…": "alquiler, teléfono, adobe…",
  "what you bought": "qué compraste",
  "who or what you owe": "a quién o qué debes",
  "what you're saving for": "para qué ahorras",
  "add": "añadir",
  "add to the budget": "añadir al presupuesto",
  "added": "añadido",
  "couldn't save that": "no se pudo guardar eso",
  "due: {title}": "vence: {title}",
  "unexpected \"{char}\"": "\"{char}\" inesperado",
  "missing )": "falta )",
  "expected a number": "se esperaba un número",
  "that goes to infinity": "eso se va al infinito",
  "not set, add it in setup": "sin poner, añádela en ajustes",
  "{spent} of {budget} for tagging": "{spent} de {budget} para etiquetar",
  "no cap on tagging": "sin límite de etiquetado",
  "{count} refs waiting since {time}": "{count} refs esperando desde las {time}",
  "none running": "nada en marcha",
  "{calls} calls · {input} in · {cached} cached · {output} out": "{calls} llamadas · {input} entrada · {cached} en caché · {output} salida",
  "nothing yet for {month}": "aún nada para {month}",
  "{calls} calls": "{calls} llamadas",
  "split starts with the next answer": "el reparto empieza con la próxima respuesta",
  "could not read claude usage": "no se pudo leer el uso de claude",
  "all": "todo",
  "start {name}?": "¿iniciar {name}?",
  "starting {name}...": "iniciando {name}...",
  "{name} start sent": "inicio de {name} enviado",
  "stop {name}?": "¿parar {name}?",
  "stopping {name}...": "parando {name}...",
  "{name} stop sent": "parada de {name} enviada",
  "restart {name}?": "¿reiniciar {name}?",
  "restarting {name}...": "reiniciando {name}...",
  "{name} restart sent": "reinicio de {name} enviado",
  "running": "en marcha",
  "stopped": "parado",
  "crash looping": "fallando en bucle",
  "starting": "iniciando",
  "up {time}": "activo {time}",
  "{count} restarts": "{count} reinicios",
  "{name} logs": "registros de {name}",
  "loading...": "cargando...",
  "{used} of {total}": "{used} de {total}",
  "could not reach the server: {error}": "no se pudo contactar con el servidor: {error}",
  "validating caddy...": "validando caddy...",
  "caddy reloaded": "caddy recargado",
  "{label}, one per line": "{label}, uno por línea",
  "change picture": "cambiar imagen",
  "all {n}": "todo {n}",
  "unsorted": "sin clasificar",
  "under a cent": "menos de un céntimo",
  "chi looking {done}/{total}": "chi mirando {done}/{total}",
  "chi look {done}/{total}": "chi mira {done}/{total}",
  "chi looked": "chi ya miró",
  "chi has looked at every character picture": "chi ya miró todas las imágenes de personajes",
  "{n} more wait for another press.": "{n} más esperan a otro toque.",
  "chi has looked at {done} of {total} character pictures. look at the next {count} for about {price}? it goes through the half price batch, so it can take a while.": "chi ha mirado {done} de {total} imágenes de personajes. ¿mirar las siguientes {count} por unos {price}? va por el lote a mitad de precio, así que puede tardar.",
  "chi is looking at {count} pictures": "chi está mirando {count} imágenes",
  "could not start chi": "no se pudo iniciar chi",
  "chi looks at 1 picture of {name} she hasn't seen, about {price}?": "¿chi mira 1 imagen de {name} que no ha visto, por unos {price}?",
  "chi looks at {count} pictures of {name} she hasn't seen, about {price}?": "¿chi mira {count} imágenes de {name} que no ha visto, por unos {price}?",
  "chi has seen all {total} pictures of {name}. look at them again from scratch, about {price}?": "chi ya vio las {total} imágenes de {name}. ¿mirarlas otra vez desde cero, por unos {price}?",
  "chi is looking at {name}": "chi está mirando a {name}",
  "picture {n}": "imagen {n}",
  "adding 1 picture…": "añadiendo 1 imagen…",
  "adding {n} pictures…": "añadiendo {n} imágenes…",
  "picture added": "imagen añadida",
  "{n} pictures added": "{n} imágenes añadidas",
  "could not add the picture": "no se pudo añadir la imagen",
  "take this picture off the character?": "¿quitar esta imagen del personaje?",
  "picture removed": "imagen quitada",
  "could not remove the picture": "no se pudo quitar la imagen",
  "sheet picture changed": "imagen de ficha cambiada",
  "could not change the picture": "no se pudo cambiar la imagen",
  "fetching characters from {source}…": "trayendo personajes de {source}…",
  "{n} found": "{n} encontrados",
  "{n} added": "{n} añadidos",
  "{n} updated": "{n} actualizados",
  "{n} duplicates merged": "{n} duplicados fusionados",
  "{n} failed": "{n} fallidos",
  "{source} import failed": "falló la importación de {source}",
  "aka {names}": "alias {names}",
  "{n} pictures": "{n} imágenes",
  "merge into {name}": "fusionar con {name}",
  "merge {other} into {name}? {other}'s sheet goes away and its pictures move to {name}.": "¿fusionar {other} con {name}? la ficha de {other} desaparece y sus imágenes pasan a {name}.",
  "{other} merged into {name}": "{other} fusionado con {name}",
  "the sheet": "la ficha",
  "could not merge": "no se pudo fusionar",
  "character saved": "personaje guardado",
  "could not save": "no se pudo guardar",
  "delete {name}?": "¿borrar {name}?",
  "1 block today": "1 bloque hoy",
  "{n} blocks today": "{n} bloques hoy",
  "resume": "seguir",
  "back to drawing": "a dibujar otra vez",
  "break time, stretch your hand": "hora del descanso, estira la mano",
  "focus block started": "bloque de concentración empezado",
  "take a break": "tómate un descanso",
  "type minutes, like 40 or 1h30": "escribe minutos, como 40 o 1h30",
  "drop this picture": "quitar esta imagen",
  "toss {hex}?": "¿tirar {hex}?",
  "copied {hex}": "{hex} copiado",
  "prompt copied": "prompt copiado",
  "commissions": "encargos",
  "no commissions": "sin encargos",
  "comms money": "dinero de encargos",
  "{n} paid": "{n} pagados",
  "{n} others": "{n} más",
  "nothing paid yet": "aún no hay nada pagado",
  "that task is done or gone": "esa tarea ya está hecha o no existe",
  "unlink {title}": "desvincular {title}",
  "no task matches": "ninguna tarea coincide",
  "no open tasks. add one in tasks first": "no hay tareas abiertas. añade una en tareas primero",
  "for {client}": "para {client}",
  "paid {day}": "pagado {day}",
  "due {date}": "vence {date}",
  "commission saved": "encargo guardado",
  "commission added": "encargo añadido",
  "break": "descanso",
  "unknown": "desconocido",
  "fapped {n} times": "fap {n} veces",
  "no doodles match": "ningún garabato coincide",
  "could not load the doodles": "no se pudieron cargar los garabatos",
  "no picture on the clipboard": "no hay imagen en el portapapeles",
  "pick a picture": "elige una imagen",
  "you can look at the doodles, not add them": "puedes ver los garabatos, no añadirlos",
  "adding the doodle": "añadiendo el garabato",
  "adding {n} of {total}": "añadiendo {n} de {total}",
  "{n} doodles added": "{n} garabatos añadidos",
  "could not add that": "no se pudo añadir eso",
  "press ctrl+v or ⌘v to paste": "pulsa ctrl+v o ⌘v para pegar",
  "couldn't read the clipboard, try ctrl+v or ⌘v": "no se pudo leer el portapapeles, prueba ctrl+v o ⌘v",
  "gone": "ya no está",
  "remove {name}": "quitar a {name}",
  "new doodle": "nuevo garabato",
  "doodle saved": "garabato guardado",
  "delete this doodle?": "¿borrar este garabato?",
  "could not delete": "no se pudo borrar",
  "by {name}": "de {name}",
  "one a day per doodle, come back tomorrow": "uno al día por garabato, vuelve mañana",
  "today ✓ {n}": "hoy ✓ {n}",
  "fapped {n}×": "fap {n}×",
  "you {n}": "tú {n}",
  "could not count that": "no se pudo contar eso",
  "random full body poses from the pocketbase library": "poses de cuerpo entero al azar de la biblioteca pocketbase",
  "{n} refs in the pool": "{n} refs en el grupo",
  "no refs match yet": "aún no coincide ninguna ref",
  "could not fetch poses": "no se pudieron traer poses",
  "play": "seguir",
  "no poses to draw from": "no hay poses para dibujar",
  "{n} poses done, nice": "{n} poses hechas, genial",
  "{n} answered today": "{n} respondidas hoy",
  "{n} day streak": "racha de {n} días",
  "nothing due right now, {n} learning cards come back in {minutes}m": "nada pendiente ahora, {n} tarjetas en aprendizaje vuelven en {minutes}m",
  "today's cards are done, see you tomorrow": "las tarjetas de hoy están hechas, hasta mañana",
  "no cards to study, switch a deck on below": "no hay tarjetas que estudiar, activa un mazo abajo",
  "{seen} of {total} seen · {solid} solid": "{seen} de {total} vistas · {solid} firmes",
  "study {deck}": "estudiar {deck}",
  "could not load the deck": "no se pudo cargar el mazo",
  "could not save that answer": "no se pudo guardar esa respuesta",
  "could not save the deck setup": "no se pudo guardar la configuración del mazo",
  "basics": "lo básico",
  "favourites": "favoritos",
  "likes and goals": "gustos y metas",
  "looks": "aspecto",
  "identity": "identidad",
  "sexuality": "sexualidad",
  "story": "historia",
  "for chi": "para chi",
  "orientation": "orientación",
  "trivia": "curiosidades",
  "created by": "creado por",
  "world": "mundo",
  "location": "ubicación",
  "race": "raza",
  "occupation": "ocupación",
  "gender": "género",
  "height": "altura",
  "favourite food": "comida favorita",
  "smell": "olor",
  "pet peeve": "manía",
  "likes": "gustos",
  "dislikes": "disgustos",
  "look in short": "aspecto en breve",
  "body": "cuerpo",
  "clothes": "ropa",
  "visual features": "rasgos visuales",
  "speaking": "forma de hablar",
  "personality": "personalidad",
  "relationships": "relaciones",
  "items": "objetos",
  "skills": "habilidades",
  "preferences": "preferencias",
  "fetishes": "fetiches",
  "sexual trivia": "curiosidades sexuales",
  "rpg sheet": "ficha de rol",
  "fractal's notes for chi": "notas de fractal para chi",
  "sees your {kinds}": "ve tus {kinds}",
  "sees nothing of yours": "no ve nada tuyo",
  "{line}, adds to your {kinds}": "{line}, añade a tus {kinds}",
  "{name} can add to your {kind}": "{name} puede añadir a tus {kind}",
  "{name} can only read your {kind}": "{name} solo puede leer tus {kind}",
  "{name} can see your {kind}": "{name} puede ver tus {kind}",
  "{kind} hidden from {name}": "{kind} ocultos para {name}",
  "{name} can see everything you can share": "{name} puede ver todo lo que puedes compartir",
  "{name} sees nothing of yours now": "{name} ya no ve nada tuyo",
  "share {kind} with {name}": "compartir {kind} con {name}",
  "you don't have notes, pings or anything else to share yet": "aún no tienes notas, avisos ni nada que compartir",
  "share all": "compartir todo",
  "share none": "no compartir nada",
  "nobody else is in chix yet": "aún no hay nadie más en chix",
  "shares their {kinds}": "comparte sus {kinds}",
  "Calendar events": "Eventos del calendario",
  "Places and routes": "Lugares y rutas",
  "your sticky notes": "tus notas adhesivas",
  "reminders, alarms and timers": "recordatorios, alarmas y temporizadores",
  "your own events on the month": "tus propios eventos del mes",
  "plane and chix bot": "plane y el bot de chix",
  "clients, prices, status, linked tasks and money stats": "clientes, precios, estado, tareas vinculadas y estadísticas de dinero",
  "bills, costs, debts and goals": "facturas, gastos, deudas y metas",
  "what you keep up and your streaks": "lo que mantienes y tus rachas",
  "spots and routes you saved on the map": "sitios y rutas que guardaste en el mapa",
  "Can add to it": "Puede añadir",
  "bills, costs, money in and payments, with their name on them. they can change only what they added": "facturas, gastos, entradas y pagos, con su nombre. solo pueden cambiar lo que añadieron",
  "off": "no",
  "{on} of {total} on · chi {spent} of {cap}": "{on} de {total} activados · chi {spent} de {cap}",
  "{on} of {total} on · chi {spent}": "{on} de {total} activados · chi {spent}",
  "{feature} off for {name}": "{feature} desactivado para {name}",
  "{name} can view {feature}": "{name} puede ver {feature}",
  "{name} can edit {feature}": "{name} puede editar {feature}",
  "{feature} for {name}": "{feature} para {name}",
  "monthly chi cap, usd": "límite mensual de chi, usd",
  "{name}'s chi stops at {amount} a month": "el chi de {name} se detiene en {amount} al mes",
  "no cap for {name}": "sin límite para {name}",
  "{spent} over {count} answers this month. 0 means no cap": "{spent} en {count} respuestas este mes. 0 significa sin límite",
  "remove {name}? they get signed out. their own notes and chats stay on the server if you add them back": "¿quitar a {name}? se cerrará su sesión. sus notas y chats se quedan en el servidor si lo vuelves a añadir",
  "{name} removed": "{name} quitado",
  "just you for now": "solo tú por ahora",
  "{name} can sign in now. they start with chi, notes, pings and routines": "{name} ya puede entrar. empieza con chi, notas, avisos y rutinas",
  "Calendar and pings": "Calendario y avisos",
  "Chi speaker": "Altavoz de Chi",
  "Discord messages": "Mensajes de discord",
  "Keys and server setup": "Claves y ajustes del servidor",
  "their own chat and memory, on your claude account": "su propio chat y memoria, en tu cuenta de claude",
  "the shared ref library": "la biblioteca compartida de refs",
  "the shared oc sheets": "las fichas de oc compartidas",
  "their own": "los suyos",
  "plane and chix bot, their own": "plane y el bot de chix, los suyos",
  "timer, palette, prompts, comms and their money stats": "temporizador, paleta, ideas, encargos y sus estadísticas de dinero",
  "their own bills, costs, debts and goals": "sus propias facturas, gastos, deudas y metas",
  "places nearby, routes and their saved spots, on your google maps key": "lugares cercanos, rutas y sus sitios guardados, con tu clave de google maps",
  "gesture drawing and japanese": "dibujo de gestos y japonés",
  "the shared doodle wall": "el muro de garabatos compartido",
  "their own scan library": "su propia biblioteca de escaneos",
  "their pings ring at home, chi answers their voice": "sus avisos suenan en casa, chi responde a su voz",
  "chi can dm your contacts for them": "chi puede escribir por dm a tus contactos por ellos",
  "vps panel and bot controls": "panel del vps y controles del bot",
  "every log line": "cada línea de registro",
  "spend and billing": "gasto y facturación",
  "api keys, ssh": "claves de api, ssh",
  "this dashboard": "este panel",
  "tap to upload": "toca para subir",
  "{count} kept": "{count} guardados",
  "uploading {n} of {total}": "subiendo {n} de {total}",
  "scan kept": "escaneo guardado",
  "{count} scans kept": "{count} escaneos guardados",
  "upload failed": "falló la subida",
  "the brother is scanning": "la brother está escaneando",
  "scan failed": "falló el escaneo",
  "saving {n} of {total}": "guardando {n} de {total}",
  "added to scans": "añadido a escaneos",
  "could not save that": "no se pudo guardar",
  "pdf scan, use download to open it": "escaneo pdf, usa descargar para abrirlo",
  "delete this scan?": "¿borrar este escaneo?",
  "days apart": "días entre medias",
  "times a week, any days": "veces por semana, cualquier día",
  "day of the month": "día del mes",
  "added by another part of chix, ticked off there too": "añadida por otra parte de chix, se marca allí también",
  "delete {title} and its history?": "¿borrar {title} y su historial?",
  "no routines": "sin rutinas",
  "ChiX routine": "Rutina de ChiX",
  "time for {title}": "hora de {title}",
  "weekdays": "entre semana",
  "every {n} days": "cada {n} días",
  "{n}x a week": "{n} veces por semana",
  "monthly on day {day}": "cada mes el día {day}",
  "{done}/{times} this week": "{done}/{times} esta semana",
  "ping {time}": "aviso {time}",
  "{n}w streak": "racha de {n} sem",
  "{n} streak": "racha de {n}",
  "{title} done": "{title} hecho",
  "sticky {date}": "nota {date}",
  "saved {time}": "guardado {time}",
  "nothing coming up": "nada próximo",
  "edit chix task": "editar tarea chix",
  "new chix task": "nueva tarea chix",
  "saving...": "guardando...",
  "mark \"{title}\" as done?": "¿marcar \"{title}\" como hecha?",
  "urgent": "urgente",
  "high": "alta",
  "medium": "media",
  "low": "baja",
  "{count} shown, updated {time}": "{count} mostradas, actualizado {time}",
  "nothing pending": "nada pendiente",
  "night": "noche",
  "fog": "niebla",
  "ember": "brasa",
  "abyss": "abismo",
  "petal": "pétalo",
  "peach": "melocotón",
  "mint": "menta",
  "lilac": "lila",
  "starlight": "luz estelar",
  "venom": "veneno",
  "pocket": "bolsillo",
  "{title} reached, tap done to cross it off": "{title} alcanzada, toca hecho para tacharla",
  "delete {title}? it won't come back": "¿borrar {title}? no volverá",
  "done · {n}": "hechas · {n}",
  "no goals": "sin metas",
  "this one's done, saving keeps it crossed out": "esta ya está hecha, al guardar sigue tachada",
  "no goals on the go": "ninguna meta en marcha",
  "add a couple of options": "añade un par de opciones",
  "last one standing: {label}": "la última en pie: {label}",
  "everything's been knocked out": "todo ha quedado eliminado",
  "spinning": "girando",
  "the wheel says": "la ruleta dice",
  "new wheel": "nueva rueda",
  "knocked out": "eliminada",
  "{n} on the wheel, {out} knocked out": "{n} en la ruleta, {out} eliminadas",
  "{n} on the wheel": "{n} en la ruleta",
  "just now": "ahora mismo",
  "{n}m ago": "hace {n} min",
  "{n}h ago": "hace {n} h",
  "ready": "listo",
  "flick the wheel or press spin": "lanza la rueda o pulsa girar",
  "add a couple of options to spin": "añade un par de opciones para girar",
  "a wheel holds {max} options": "una ruleta admite {max} opciones",
  "only {room} fit, a wheel holds {max}": "solo caben {room}, una ruleta admite {max}",
  "my characters": "mis personajes",
  "there aren't enough characters yet": "aún no hay suficientes personajes",
  "which oc": "qué oc",
  "{name} copy": "{name} copia",
  "delete the wheel \"{name}\"?": "¿borrar la ruleta \"{name}\"?",
  "yes or no": "sí o no",
  "what to draw": "qué dibujar",
  "dinner": "cena",
  "dice": "dado",
  "who does it": "quién lo hace",
  "yes": "sí",
  "gesture warm up": "calentamiento de gestos",
  "portrait": "retrato",
  "an oc": "un oc",
  "hands and feet": "manos y pies",
  "background": "fondo",
  "comic page": "página de cómic",
  "redraw an old piece": "redibujar una obra antigua",
  "burgers": "hamburguesas",
  "noodles": "fideos",
  "cook something": "cocinar algo",
  "yellow": "amarillo",
  "orange": "naranja",
  "lime": "lima",
  "teal": "verde azulado",
  "blue": "azul",
  "purple": "morado",
  "pink": "rosa",
  "white": "blanco",
  "black": "negro",
  "sky": "cielo",
  "slate": "pizarra",
  "edit message": "editar mensaje",
  "delete your message? it goes for everyone": "¿borrar tu mensaje? desaparece para todos",
  "delete {name}'s message? it goes for everyone": "¿borrar el mensaje de {name}? desaparece para todos",
  "couldn't delete that": "no se pudo borrar",
  "couldn't post that": "no se pudo publicar",
  "1 message": "1 mensaje",
  "{n} messages": "{n} mensajes",
  "someone": "alguien",
  "edited": "editado",
  "now": "ahora",
  "{n}m": "{n} min",
  "{n}h": "{n} h",
  "+{n} more": "+{n} más",
  "couldn't switch": "no se pudo cambiar",
  "switch": "cambiar",
  "profile": "perfil",
  "that isn't a picture": "eso no es una imagen",
  "picture saved": "imagen guardada",
  "upload picture": "subir imagen",
  "use {name}'s discord picture": "usar la imagen de discord de {name}",
  "remove picture": "quitar imagen",
  "owned by": "propiedad de",
  "remove {name} as an owner": "quitar a {name} como propietario",
  "owner removed": "propietario quitado",
  "another discord user id": "otro id de usuario de discord",
  "discord user id": "id de usuario de discord",
  "add owner": "añadir propietario",
  "they can sign in as {name} now": "ya pueden entrar como {name}",
  "a discord account that owns an alter can sign in and switch to it, so give the alter's own account here": "una cuenta de discord que posee un alter puede entrar y cambiar a él, así que pon aquí la cuenta propia del alter",
  "she/her, they/them…": "ella, elle…",
  "a line about them": "una línea sobre ellos",
  "pronouns": "pronombres",
  "about": "acerca de",
  "be {name}": "ser {name}",
  "{name} is part of {system}": "{name} forma parte de {system}",
  "back to my profile": "volver a mi perfil",
  "remove {name}? their notes and chats stay on the server if you add them back": "¿quitar a {name}? sus notas y chats se quedan en el servidor si lo vuelves a añadir",
  "no alters yet. add the first one above": "aún no hay alters. añade el primero arriba",
  "{name} added": "{name} añadido",
  "size: {size}, change": "tamaño: {size}, cambiar",
  "small": "pequeña",
  "half": "medio",
  "wide": "ancho",
  "hide": "ocultar",
  "move earlier": "mover antes",
  "move later": "mover después",
  "hold to drag": "mantén para arrastrar",
  "arrange home": "ordenar inicio",
  "ask chi": "pregunta a chi",
  "inbox": "bandeja",
  "gauges": "indicadores",
  "message board": "tablón de mensajes",
  "spin": "girar",
  "cat": "gato",
  "Cat mode": "Modo gato",
  "press ALT P TO EXIT CAT MODE": "pulsa ALT P PARA SALIR DEL MODO GATO",
  "{n} lines": "{n} trazos",
  "live": "en vivo",
  "no shared boards yet. make one and everyone can draw on it together": "aún no hay pizarras compartidas. crea una y todos dibujan juntos",
  "no shared boards yet. Fractal can make one": "aún no hay pizarras compartidas. Fractal puede crear una",
  "{shared} shared · {mine} yours": "{shared} compartidas · {mine} tuyas",
  "could not load the boards": "no se pudieron cargar las pizarras",
  "could not make a board": "no se pudo crear la pizarra",
  "that board was deleted": "esa pizarra se borró",
  "shared board": "pizarra compartida",
  "board": "tablero",
  "offline, will send when back": "sin conexión, se enviará al volver",
  "that's someone else's, only they can change it": "eso es de otra persona, solo esa persona puede cambiarlo",
  "lost the board": "se perdió la pizarra",
  "that layer is hidden, show it to draw": "esa capa está oculta, muéstrala para dibujar",
  "that layer is hidden, show it to write": "esa capa está oculta, muéstrala para escribir",
  "that layer is locked": "esa capa está bloqueada",
  "that layer is {who}'s, ask them to let you draw on it": "esa capa es de {who}, pídele que te deje dibujar en ella",
  "that layer has other people's lines, use the stroke eraser": "esa capa tiene trazos de otras personas, usa el borrador de trazos",
  "pencil found, fingers now move the board": "lápiz detectado, ahora los dedos mueven la pizarra",
  "{n} frames": "{n} fotogramas",
  "open": "abrir",
  "empty": "vacía",
  "this layer is yours": "esta capa es tuya",
  "{who}'s layer": "capa de {who}",
  ", open to everyone": ", abierta a todos",
  ", only they draw here": ", solo esa persona dibuja aquí",
  "frames": "fotogramas",
  "animate": "animar",
  "layer {n}": "capa {n}",
  "delete {name}? you can undo it": "¿borrar {name}? se puede deshacer",
  "{name} cleared, undo brings it back": "{name} vaciada, deshacer la recupera",
  "{n} frames is the most a layer holds": "una capa admite {n} fotogramas como máximo",
  "delete frame {n}? you can undo it": "¿borrar el fotograma {n}? se puede deshacer",
  "frame {n}": "fotograma {n}",
  "frames per second": "fotogramas por segundo",
  "onion skin {state}": "papel cebolla {state}",
  "shared · look only": "compartida · solo ver",
  "shared · live": "compartida · en vivo",
  "private": "privada",
  "paper {color}": "papel {color}",
  "could not make the picture": "no se pudo crear la imagen",
  "draw something first": "dibuja algo primero",
  "posted to the doodle wall": "publicado en el muro de garabatos",
  "could not post it": "no se pudo publicar",
  "delete {name}? this can't be undone": "¿borrar {name}? no se puede deshacer",
  "delete {name}? this can't be undone, and it goes for everyone": "¿borrar {name}? no se puede deshacer y se borra para todos",
  "could not delete it": "no se pudo borrar",
  "could not open that board": "no se pudo abrir esa pizarra",
  "brush": "pincel",
  "erase": "borrar",
  "select": "elegir",
  "shape": "forma",
  "text": "texto",
  "move": "mover",
  "line": "línea",
  "arrow": "flecha",
  "box": "caja",
  "ellipse": "elipse",
  "rub out": "frotar",
  "whole strokes": "trazos enteros",
  "duplicate": "duplicar",
  "delete": "borrar",
  "done": "hecho",
  "drag to pick, tap one stroke": "arrastra para elegir, toca un trazo",
  "show": "mostrar",
  "lock": "bloquear",
  "unlock": "desbloquear",
  "move up": "subir",
  "move down": "bajar",
  "stop playing": "detener",
  "play this layer": "reproducir esta capa",
  "previous frame": "fotograma anterior",
  "next frame": "fotograma siguiente",
  "new empty frame": "fotograma vacío nuevo",
  "copy this frame": "copiar este fotograma",
  "delete this frame": "borrar este fotograma",
  "move this frame earlier": "mover este fotograma antes",
  "move this frame later": "mover este fotograma después",
  "plain": "liso",
  "lines": "líneas",
  "pen": "bolígrafo",
  "pencil": "lápiz",
  "ink": "tinta",
  "marker": "rotulador",
  "glow": "brillo",
  "eraser": "borrador",
  "water": "agua",
  "air": "aire",
  "spray": "espray",
  "coal": "carbón",
  "chalk": "tiza",
  "crayon": "cera",
  "rainbow": "arcoíris",
  "glitter": "purpurina",
  "neon": "neón",
  "boil": "hervir",
  "wave": "onda",
  "flame": "llama",
  "march": "marcha",
  "pulse": "pulso",
  "draw": "dibujo",
  "paint": "pintura",
  "texture": "textura",
  "steady": "estable",
  "pressure": "presión",
  "soft": "suave",
  "spread": "dispersión",
  "reset this brush": "restablecer este pincel",
  "multiply": "multiplicar",
  "screen": "trama",
  "overlay": "superponer",
  "soft light": "luz suave",
  "hard light": "luz fuerte",
  "darken": "oscurecer",
  "lighten": "aclarar",
  "color dodge": "sobreexponer color",
  "color burn": "subexponer color",
  "difference": "diferencia",
  "exclusion": "exclusión",
  "Goals": "Metas",
  "me": "yo",
  "Profile": "Perfil",
  "Message board": "Tablero de mensajes",
  "Roulette": "Ruleta",
  "Whiteboards": "Pizarras",
  "nothing on the board yet": "aún no hay nada en el tablero",
  "add to a": "añadir a un",
  "default": "predeterminado",
  "out of": "de",
  "no goals yet. add one for a chapter to finish, a page count to hit or anything you're working towards": "aún no hay metas. añade una para un capítulo por terminar, un número de páginas o lo que persigas",
  "kana is the standard gojūon table. kanji are the 2,211 jlpt n5 to n1 kanji, meanings and readings from kanjidic2 (edrdg, cc by-sa 4.0), levels from jonathan waller's jlpt lists (cc by)": "el kana es la tabla gojūon estándar. los kanji son los 2.211 kanji del jlpt n5 a n1, con significados y lecturas de kanjidic2 (edrdg, cc by-sa 4.0) y niveles de las listas jlpt de jonathan waller (cc by)",
  "bring all back": "traer todo de vuelta",
  "slices": "porciones",
  "history": "historial",
  "options": "opciones",
  "pasting a list adds them all. pizza *3 makes pizza three times as likely, and the weights below set it per slice": "pegar una lista los añade todos. pizza *3 hace la pizza tres veces más probable, y los pesos de abajo lo ajustan por porción",
  "no options yet. add a few, or start from a preset in options": "aún no hay opciones. añade algunas o empieza con un preajuste en opciones",
  "shuffle": "mezclar",
  "even odds": "mismas probabilidades",
  "theme colours": "colores del tema",
  "tally": "recuento",
  "last spins": "últimos giros",
  "nothing spun on this wheel yet": "aún no se ha girado esta rueda",
  "after a spin": "después de girar",
  "keep it": "dejarlo",
  "knock it out": "eliminarlo",
  "knock it out takes each winner off the wheel until you bring them all back, good for turns and tournaments": "eliminarlo saca a cada ganador de la rueda hasta que los traigas de vuelta, ideal para turnos y torneos",
  "spin length": "duración del giro",
  "quick": "rápido",
  "clicks and a jingle": "clics y una melodía",
  "new wheel from": "nueva rueda desde",
  "copy this wheel": "copiar esta rueda",
  "delete wheel": "borrar rueda",
  "winners are picked with your device's secure random, in proportion to each slice's weight, so a slice that looks twice as big really is twice as likely": "los ganadores se eligen con el aleatorio seguro de tu dispositivo, en proporción al peso de cada porción, así que una porción que se ve el doble de grande de verdad es el doble de probable",
  "wheel": "rueda",
  "the wheel, flick it to spin": "la rueda, lánzala para girar",
  "add options, one per line": "añade opciones, una por línea",
  "option": "opción",
  "weight": "peso",
  "less likely": "menos probable",
  "more likely": "más probable",
  "less": "menos",
  "more": "más",
  "shared": "compartidas",
  "new board": "nueva pizarra",
  "mine · private": "mía · privada",
  "no boards of your own yet. only you ever see these": "aún no tienes pizarras propias. solo tú las ves",
  "layers": "capas",
  "opacity": "opacidad",
  "blend": "fusión",
  "let others draw on this layer": "dejar que otros dibujen en esta capa",
  "brush ·": "pincel ·",
  "pick from the board": "elegir del tablero",
  "recent": "recientes",
  "any colour": "cualquier color",
  "paper": "papel",
  "only the pencil draws, fingers move and zoom the board": "solo el lápiz dibuja, los dedos mueven y hacen zoom en el tablero",
  "fit": "ajustar",
  "save png": "guardar png",
  "post to doodles": "publicar en garabatos",
  "two fingers pinch and move, tap two fingers to undo, three to redo. on a keyboard: space drags, [ and ] size, ⌘z undo, k brushes, x erases whole strokes, t text, v select, u shapes, comma and full stop step frames, backslash plays": "dos dedos pellizcan y mueven, toca con dos dedos para deshacer, con tres para rehacer. con teclado: espacio arrastra, [ y ] tamaño, ⌘z deshacer, k pinceles, x borra trazos enteros, t texto, v seleccionar, u formas, coma y punto cambian de fotograma, barra invertida reproduce",
  "delete board": "borrar pizarra",
  "Board": "Tablero",
  "everyone on chi sees this": "todos en chi ven esto",
  "nothing on the board yet. post the first line": "aún no hay nada en el tablero. publica la primera línea",
  "who's here": "quién está aquí",
  "who is here": "quién está aquí",
  "jot to inbox": "apuntar en la bandeja",
  "say something to everyone": "dile algo a todos",
  "message for the board": "mensaje para el tablero",
  "finish the chapter 2 sprites…": "terminar los sprites del capítulo 2…",
  "why, or what done looks like, optional": "por qué, o cómo se ve terminado, opcional",
  "progress": "progreso",
  "counting what": "contando qué",
  "a board everyone can draw on together": "una pizarra donde todos pueden dibujar juntos",
  "a board only you can see": "una pizarra que solo tú ves",
  "text on the board": "texto en el tablero",
  "back to the boards": "volver a las pizarras",
  "undo, or tap with two fingers": "deshacer, o toca con dos dedos",
  "redo": "rehacer",
  "redo, or tap with three fingers": "rehacer, o toca con tres dedos",
  "fit the drawing on screen": "ajustar el dibujo a la pantalla",
  "fit to the drawing": "ajustar al dibujo",
  "board settings": "ajustes de la pizarra",
  "brush size": "tamaño del pincel",
  "say something to everyone…": "dile algo a todos…",
  "new alter name": "nombre del nuevo alter",
  "all {count} presets are taken, unpin one first": "los {count} preajustes están ocupados, suelta uno primero",
  "could not change the owner": "no se pudo cambiar el dueño",
  "description": "descripción",
  "groups": "grupos",
  "large": "grande",
  "layout": "diseño",
  "mine {n}": "mías {n}",
  "owners": "dueños",
  "presets": "preajustes",
  "reversed": "invertido",
  "sort by": "ordenar por",
  "tap the star on a key to pin it. pins sit above the dock as presets": "toca la estrella de una tecla para fijarla. las fijadas quedan sobre el dock como preajustes",
  "unknown date": "fecha desconocida",
  "{name} is not yours any more": "{name} ya no es tuyo",
  "{name} is yours now": "{name} ahora es tuyo",
  "Grid": "Cuadrícula",
  "Masonry": "Mosaico",
  "Rows": "Filas",
  "Big grid": "Cuadrícula grande",
  "Wall": "Muro",
  "Posts": "Publicaciones",
  "Shuffle": "Mezclar",
  "random order, rolled once while it is open": "orden aleatorio, sorteado una vez mientras está abierto",
  "Newest": "Más recientes",
  "latest saved first": "lo último guardado primero",
  "Oldest": "Más antiguos",
  "earliest saved first": "lo primero guardado primero",
  "Most tagged": "Más etiquetados",
  "refs with the most tags first": "primero las refs con más etiquetas",
  "Undescribed first": "Sin descripción primero",
  "what has no description yet comes first": "lo que aún no tiene descripción va primero",
  "By tag": "Por etiqueta",
  "grouped under the most used tag": "agrupadas bajo la etiqueta más usada",
  "By author": "Por autor",
  "grouped A to Z": "agrupadas de la A a la Z",
  "By month": "Por mes",
  "grouped by the month you saved them": "agrupadas por el mes en que las guardaste",
  "By type": "Por tipo",
  "stills, gifs and clips apart": "imágenes, gifs y clips por separado",
  "sign in with discord · fractal and pauline": "entra con discord · fractal y pauline",
  "continue with discord": "continuar con discord",
  "use": "usar",
  "Ready when you are.": "Lista cuando quieras.",
  "unit": "unidad",
  "chi · online": "chi · en línea",
  "clear": "clara",
  "tip of the day": "consejo del día",
  "another one": "otro",
  "add to a budget": "añadir a un presupuesto",
  "every month": "cada mes",
  "up next": "lo siguiente",
  "all tasks": "todas las tareas",
  "nothing due, go draw": "nada pendiente, a dibujar",
  "routines": "rutinas",
  "routines done for today": "rutinas hechas por hoy",
  "notes": "notas",
  "no notes yet": "aún no hay notas",
  "Tasks": "Tareas",
  "chix task": "tarea chix",
  "Notes": "Notas",
  "note": "nota",
  "scratchpad": "borrador",
  "edit": "editar",
  "view": "ver",
  "random": "aleatorio",
  "newest": "más nuevos",
  "oldest": "más antiguos",
  "by tag": "por etiqueta",
  "stills": "imágenes",
  "moving": "animados",
  "chi's description": "descripción de chi",
  "your note": "tu nota",
  "ctrl+enter saves and goes next": "ctrl+enter guarda y pasa al siguiente",
  "edit tags": "editar etiquetas",
  "close": "cerrar",
  "dialog": "diálogo",
  "next": "siguiente",
  "Chi online. What are we drawing?": "Chi en línea. ¿Qué dibujamos?",
  "what should I work on?": "¿en qué debería trabajar?",
  "pose refs": "refs de poses",
  "pick an oc": "elige un oc",
  "comms": "encargos",
  "Routines": "Rutinas",
  "routine": "rutina",
  "every day": "cada día",
  "on these days": "estos días",
  "every few days": "cada pocos días",
  "times a week": "veces por semana",
  "once a month": "una vez al mes",
  "mon": "lun",
  "tue": "mar",
  "wed": "mié",
  "thu": "jue",
  "fri": "vie",
  "sat": "sáb",
  "sun": "dom",
  "ping at": "aviso a las",
  "paused": "en pausa",
  "cancel": "cancelar",
  "nothing on today": "nada para hoy",
  "other days": "otros días",
  "no routines yet. add one for a daily sketch, a weekly stream or anything you want to keep up": "aún no hay rutinas. añade una para un boceto diario, un stream semanal o lo que quieras mantener",
  "Pings": "Avisos",
  "reminder": "recordatorio",
  "alarm": "alarma",
  "timer": "temporizador",
  "once": "una vez",
  "daily": "diario",
  "weekly": "semanal",
  "set": "poner",
  "no pings yet. set one for a stream, a deadline or a break": "aún no hay avisos. pon uno para un stream, una entrega o un descanso",
  "Session": "Sesión",
  "focus": "concentración",
  "start": "empezar",
  "tap the time to type your own, like 40 or 1h30": "toca la hora para escribir la tuya, como 40 o 1h30",
  "0 blocks today": "0 bloques hoy",
  "Palette": "Paleta",
  "keep": "guardar",
  "tap a swatch to copy it, hold to toss it": "toca un color para copiarlo, mantén para tirarlo",
  "save prompt": "guardar prompt",
  "tap a card to copy the whole prompt": "toca una tarjeta para copiar el prompt entero",
  "Comms": "Encargos",
  "tap a commission to edit it": "toca un encargo para editarlo",
  "list": "lista",
  "money": "dinero",
  "new commission": "nuevo encargo",
  "sketch": "boceto",
  "wip": "en curso",
  "review": "revisión",
  "reference pics": "imágenes de referencia",
  "this month": "este mes",
  "this year": "este año",
  "to be paid": "por cobrar",
  "paid by month": "cobrado por mes",
  "by client": "por cliente",
  "by status": "por estado",
  "a commission counts on the day it was marked paid. change that day on its card": "un encargo cuenta el día en que se marcó pagado. cambia ese día en su tarjeta",
  "Budget": "Presupuesto",
  "left": "queda",
  "in and out": "entradas y salidas",
  "monthly by category": "mensual por categoría",
  "debts and goals": "deudas y metas",
  "one off": "puntual",
  "monthly": "mensual",
  "bills": "facturas",
  "costs": "gastos",
  "debts": "deudas",
  "goals": "metas",
  "nothing here yet. add a bill, a debt or a goal above": "aún no hay nada. añade una factura, una deuda o una meta arriba",
  "only you see this unless you switch it on for someone in sharing. paid commissions count as money in": "solo tú ves esto salvo que lo actives para alguien en compartir. los encargos pagados cuentan como entradas",
  "Gesture": "Gesto",
  "timed poses, draw fast, the next one drops in on its own": "poses cronometradas, dibuja rápido, la siguiente llega sola",
  "source": "fuente",
  "full body": "cuerpo entero",
  "my refs": "mis refs",
  "each pose": "cada pose",
  "pause": "pausa",
  "skip": "saltar",
  "Japanese": "Japonés",
  "learning": "aprendiendo",
  "show answer": "ver respuesta",
  "again": "otra vez",
  "hard": "difícil",
  "good": "bien",
  "easy": "fácil",
  "space shows the answer, 1 to 4 grades it": "espacio muestra la respuesta, 1 a 4 la califica",
  "decks": "mazos",
  "new cards a day": "cartas nuevas al día",
  "study, new cards come in this order": "estudio, las cartas nuevas llegan en este orden",
  "Characters": "Personajes",
  "chi look": "mirada de chi",
  "no characters match": "ningún personaje coincide",
  "new character": "nuevo personaje",
  "name": "nombre",
  "tags, comma separated": "etiquetas, separadas por comas",
  "sheet picture": "imagen de ficha",
  "character file": "archivo del personaje",
  "chi saw": "chi vio",
  "use as picture": "usar como imagen",
  "add pic": "añadir imagen",
  "drop pic": "quitar imagen",
  "merge": "fusionar",
  "merge into": "fusionar con",
  "pick the same character under another name. its pictures and anything this sheet is missing move here, and imports will update this sheet from then on.": "elige el mismo personaje con otro nombre. sus imágenes y lo que le falte a esta ficha pasan aquí, y desde entonces las importaciones actualizarán esta ficha.",
  "Calendar": "Calendario",
  "Maps": "Mapas",
  "near me": "cerca de mí",
  "maps needs a google key": "mapas necesita una clave de google",
  "in console.cloud.google.com make a project and turn on billing": "en console.cloud.google.com crea un proyecto y activa la facturación",
  "turn on": "activa",
  "and": "y",
  "make an api key under credentials, and limit it to those three apis": "crea una clave de api en credenciales y limítala a esas tres apis",
  "paste it in setup, keys, google maps. or put it on the server as GOOGLE_MAPS_API_KEY": "pégala en ajustes, claves, google maps. o ponla en el servidor como GOOGLE_MAPS_API_KEY",
  "open setup": "abrir ajustes",
  "search this area": "buscar en esta zona",
  "route here": "ruta hasta aquí",
  "route from": "ruta desde",
  "remove": "quitar",
  "nearby": "cerca",
  "route": "ruta",
  "best rated": "mejor valorados",
  "most reviews": "más reseñas",
  "closest": "más cerca",
  "parking first": "aparcamiento primero",
  "add where you start and where you're going. places from nearby can go in with their route button": "añade de dónde sales y a dónde vas. los lugares de cerca pueden entrar con su botón de ruta",
  "from here": "desde aquí",
  "home": "casa",
  "best order for the middle stops": "mejor orden para las paradas intermedias",
  "plan route": "planear ruta",
  "time": "tiempo",
  "distance": "distancia",
  "stops": "paradas",
  "pins": "pines",
  "tap drop a pin, then tap the map where it goes": "toca poner un pin y luego toca el mapa donde va",
  "pin where i am": "pin donde estoy",
  "places": "lugares",
  "star a place from nearby to keep it here": "marca con estrella un lugar de cerca para guardarlo aquí",
  "routes": "rutas",
  "plan a route and save it to keep it here": "planea una ruta y guárdala para tenerla aquí",
  "only you see these unless you switch places and routes on for someone in sharing": "solo tú ves esto salvo que actives lugares y rutas para alguien en compartir",
  "tape": "cinta",
  "Scans": "Escaneos",
  "photo": "foto",
  "scan": "escanear",
  "on this pc": "en este pc",
  "upload all": "subir todo",
  "scans the brother left in the inbox folder that the web cannot see yet": "escaneos que la brother dejó en la carpeta de entrada y que la web aún no ve",
  "no scans yet. scan on the pc, or snap a photo of a sketch": "aún no hay escaneos. escanea en el pc o haz una foto de un boceto",
  "Doodles": "Garabatos",
  "paste": "pegar",
  "no doodles yet. paste one, or add pictures from your phone": "aún no hay garabatos. pega uno o añade imágenes desde tu móvil",
  "doodle": "garabato",
  "title": "título",
  "drawn by": "dibujado por",
  "day": "día",
  "characters in it": "personajes que salen",
  "undo mine": "deshacer el mío",
  "newer": "más nuevo",
  "older": "más antiguo",
  "Server": "Servidor",
  "reload caddy": "recargar caddy",
  "memory": "memoria",
  "load": "carga",
  "bots up": "bots activos",
  "Logs": "Registros",
  "nothing happened yet, it shows up here live": "aún no ha pasado nada, aparece aquí en directo",
  "billing": "facturación",
  "month": "mes",
  "tags": "etiquetas",
  "key": "clave",
  "tagging": "etiquetado",
  "budget": "presupuesto",
  "batch": "lote",
  "by model": "por modelo",
  "by person": "por persona",
  "estimates from the token counts claude sends back. billing has the real bill": "estimaciones según los tokens que devuelve claude. la facturación tiene la cuenta real",
  "People": "Personas",
  "let in": "dejar entrar",
  "their chi": "su chi",
  "yours": "tuyo",
  "everyone talks to chi on your claude key. they never see it, their chats and memory stay their own, and their share of the bill is counted here": "todos hablan con chi con tu clave de claude. nunca la ven, sus chats y memoria son suyos, y su parte de la cuenta se cuenta aquí",
  "let someone in": "dejar entrar a alguien",
  "they sign in with discord. if they try before you add them, the page shows them their id to send you": "entran con discord. si lo intentan antes de que los añadas, la página les muestra su id para que te lo manden",
  "only you": "solo tú",
  "Sharing": "Compartir",
  "pick what each person can see. they can only read it, never change it. it shows up next to their own notes, pings and the rest, and their chi can read it too": "elige qué puede ver cada persona. solo pueden leerlo, nunca cambiarlo. aparece junto a sus propias notas, avisos y demás, y su chi también puede leerlo",
  "shared with you": "compartido contigo",
  "nobody shares anything with you yet": "aún nadie comparte nada contigo",
  "Setup": "Ajustes",
  "assistant": "asistente",
  "anthropic api key": "clave de api de anthropic",
  "chat model": "modelo de chat",
  "ref tagging model": "modelo de etiquetado de refs",
  "monthly tagging budget, usd": "presupuesto mensual de etiquetado, usd",
  "tagging pauses once the month's estimate passes the budget. 0 means no cap. claude-haiku-4-5 tags cheaper": "el etiquetado se pausa cuando la estimación del mes supera el presupuesto. 0 es sin límite. claude-haiku-4-5 etiqueta más barato",
  "currency": "moneda",
  "yours only. the sign shown on comms, money stats and the budget. auto reads it from what you type on commissions. it saves as soon as you pick": "solo tuya. el símbolo de los encargos, las estadísticas de dinero y el presupuesto. auto lo lee de lo que escribes en los encargos. se guarda en cuanto eliges",
  "log into the plane tab, then connect": "entra en la pestaña de plane y luego conecta",
  "open plane, make an api token in profile settings, paste it here": "abre plane, crea un token de api en ajustes del perfil y pégalo aquí",
  "connect plane": "conectar plane",
  "workspace slug": "slug del espacio",
  "api key": "clave de api",
  "load boards": "cargar tableros",
  "chix bot": "bot chix",
  "api url": "url de la api",
  "your discord user id": "tu id de usuario de discord",
  "browser key, optional": "clave de navegador, opcional",
  "the api key searches places and plans routes from the server. the map itself loads with the browser key if there is one, otherwise the api key. GOOGLE_MAPS_API_KEY on the server wins over this": "la clave de api busca lugares y planea rutas desde el servidor. el mapa carga con la clave de navegador si hay una, si no con la de api. GOOGLE_MAPS_API_KEY en el servidor tiene prioridad",
  "server": "servidor",
  "bots folder": "carpeta de bots",
  "sudo password": "contraseña sudo",
  "ssh host": "host ssh",
  "ssh user": "usuario ssh",
  "ssh key file": "archivo de clave ssh",
  "browser extension": "extensión del navegador",
  "paste this into the extension options as the cloud token. it's yours, so saves land as you": "pega esto en las opciones de la extensión como token de la nube. es tuyo, así que lo guardado queda a tu nombre",
  "chrome: unzip over the old folder and hit reload in chrome://extensions. firefox: open the file in firefox and allow it, it updates itself after that": "chrome: descomprime encima de la carpeta vieja y pulsa recargar en chrome://extensions. firefox: abre el archivo en firefox y permítelo, luego se actualiza sola",
  "your extension token": "tu token de extensión",
  "copy": "copiar",
  "new token": "nuevo token",
  "links": "enlaces",
  "one per line as name | url. they open inside the desk app, or in a new tab on the web": "uno por línea como nombre | url. se abren dentro de la app de escritorio o en una pestaña nueva en la web",
  "desk": "escritorio",
  "cloud url": "url de la nube",
  "cloud token": "token de la nube",
  "chrome extension token": "token de la extensión de chrome",
  "brother scan folder": "carpeta de escaneos brother",
  "start with windows": "iniciar con windows",
  "security": "seguridad",
  "signs out every phone, tablet and browser that is logged in, including this one. use it if a device was lost or you think someone got in": "cierra la sesión en todos los móviles, tablets y navegadores conectados, este incluido. úsalo si perdiste un dispositivo o crees que alguien entró",
  "log out everywhere": "cerrar sesión en todas partes",
  "pick a look": "elige un estilo",
  "background pattern": "patrón de fondo",
  "film grain and fog": "grano de película y niebla",
  "calm motion": "movimiento suave",
  "retry": "reintentar",
  "toss": "tirar",
  "logs": "registros",
  "paid on": "pagado el",
  "undo": "deshacer",
  "setup token": "token de configuración",
  "talk to chi": "hablar con chi",
  "jot into inbox": "apuntar en la bandeja",
  "whose budget": "presupuesto de quién",
  "what kind": "qué tipo",
  "what it is": "qué es",
  "ask chi…": "pregunta a chi…",
  "ask": "preguntar",
  "refresh": "actualizar",
  "find a task": "buscar una tarea",
  "just type, it saves itself": "solo escribe, se guarda solo",
  "search notes": "buscar notas",
  "back": "atrás",
  "print": "imprimir",
  "# heading\n\nmarkdown works, autosave is on": "# título\n\nmarkdown funciona, autoguardado activo",
  "search refs, tags, characters": "buscar refs, etiquetas, personajes",
  "tile size": "tamaño de mosaico",
  "add pictures": "añadir imágenes",
  "sort the feed": "ordenar el feed",
  "what you want to remember about this": "lo que quieres recordar de esto",
  "re-index": "reindexar",
  "open post": "abrir post",
  "message chi": "escribir a chi",
  "send": "enviar",
  "a sketch a day…": "un boceto al día…",
  "how often": "cada cuánto",
  "how many": "cuántas",
  "note, optional": "nota, opcional",
  "nudge me about…": "recuérdame…",
  "kind": "tipo",
  "set the time": "poner la hora",
  "minutes, like 40 or 1h30": "minutos, como 40 o 1h30",
  "reset": "reiniciar",
  "another tip": "otro consejo",
  "pick a colour": "elige un color",
  "name, like sitting nsfw": "nombre, como sentada nsfw",
  "piece": "pieza",
  "client (for the money stats)": "cliente (para las estadísticas de dinero)",
  "amount": "importe",
  "due": "entrega",
  "what they want drawn": "lo que quieren que dibujes",
  "previous month": "mes anterior",
  "next month": "mes siguiente",
  "what is it": "qué es",
  "owed": "debido",
  "category": "categoría",
  "only refs matching… (optional)": "solo refs que coincidan… (opcional)",
  "add the characters from zirk.eu/oc": "añadir los personajes de zirk.eu/oc",
  "add the characters from the discord character channel": "añadir los personajes del canal de personajes de discord",
  "chi looks at character pictures and writes tags and a line about each, so she picks better characters and refs": "chi mira las imágenes de los personajes y escribe etiquetas y una línea sobre cada uno, para elegir mejor personajes y refs",
  "search name, race, likes, fetishes…": "buscar nombre, raza, gustos, fetiches…",
  "search characters…": "buscar personajes…",
  "reload": "recargar",
  "add an event": "añadir un evento",
  "map": "mapa",
  "name it: studio, mum's, good parking": "ponle nombre: estudio, casa de mamá, buen aparcamiento",
  "a note, optional": "una nota, opcional",
  "colour": "color",
  "sushi, art supplies, an address": "sushi, material de arte, una dirección",
  "how far": "a qué distancia",
  "add a stop: address, postcode or place": "añade una parada: dirección, código postal o lugar",
  "add stop": "añadir parada",
  "download": "descargar",
  "add the picture on your clipboard, or press ctrl+v": "añade la imagen del portapapeles o pulsa ctrl+v",
  "search title, artist, character, tag…": "buscar título, artista, personaje, etiqueta…",
  "untitled": "sin título",
  "type a name to add a character": "escribe un nombre para añadir un personaje",
  "count a fap": "contar un fap",
  "console.anthropic.com, api keys": "console.anthropic.com, claves de api",
  "the part after the domain": "la parte después del dominio",
  "maps javascript, places (new) and routes": "maps javascript, places (new) y routes",
  "only if the map should load with its own key": "solo si el mapa debe cargar con su propia clave",
  "find a tool or place": "busca una herramienta o lugar",
  "what needs doing?": "¿qué hay que hacer?",
  "optional notes": "notas opcionales",
  "index": "índice",
  "mark done": "marcar hecho",
  "status": "estado",
  "link a task": "vincular una tarea",
  "find a plane or chix task": "busca una tarea de plane o chix",
  "take back the last one": "quitar el último",
  "take out": "quitar",
  "tasks": "tareas",
  "Today": "Hoy",
  "References": "Referencias",
  "describe": "describir",
  "Ask ChiX": "Pregunta a ChiX",
  "gesture": "gesto",
  "Gesture drawing": "Dibujo gestual",
  "Session timer": "Temporizador de sesión",
  "palette": "paleta",
  "Commissions": "Encargos",
  "maps": "mapas",
  "Calculator": "Calculadora",
  "doodles": "garabatos",
  "scans": "escaneos",
  "Claude usage": "Uso de Claude",
  "people": "personas",
  "share": "compartir",
  "setup": "ajustes",
  "keys": "claves",
  "themes": "temas",
  "studio": "estudio",
  "system": "sistema",
  "Home": "Inicio",
  "Studio": "Estudio",
  "Practice": "Práctica",
  "Ledger": "Cuentas",
  "Library": "Biblioteca",
  "Core": "Núcleo",
  "language": "idioma",
  "yours only. the app's words and chi's replies follow it. it saves as soon as you pick": "solo tuyo. los textos de la app y las respuestas de chi lo siguen. se guarda en cuanto eliges",
  "Quick note": "Nota rápida",
  "Reminders": "Recordatorios",
  "Ubuntu helpers": "Ayudas de Ubuntu",
  "Quit": "Salir",
  "open {name}": "abrir {name}",
  "sort": "orden",
  "this one is mine": "este es mío",
  "reverse the order": "invertir el orden",
  "filter": "filtro",
  "{name} can sign in now. they start with chi, notes, pings, routines and goals": "{name} ya puede entrar. empieza con chi, notas, avisos, rutinas y metas",
  "no type": "sin tipo",
  "new type": "nuevo tipo",
  "no price": "sin precio",
  "{n} open": "{n} abiertos",
  "settled": "saldado",
  "{amount} owed": "debe {amount}",
  "{amount} credit": "{amount} de crédito",
  "even": "en paz",
  "take this back": "deshacer esto",
  "{paid} paid · {owed} still owed": "{paid} pagado · faltan {owed}",
  "{paid} paid, settled": "{paid} pagado, saldado",
  "from credit": "de crédito",
  "use {amount} credit": "usar {amount} de crédito",
  "pay {amount} in full": "pagar {amount} completo",
  "{n} characters": "{n} personajes",
  "{n} references": "{n} referencias",
  "take off": "quitar",
  "{n} saved": "{n} guardadas",
  "default currency": "moneda por defecto",
  "chi is looking...": "chi está mirando...",
  "let chi describe them": "que chi los describa",
  "add a character": "añadir un personaje",
  "{amount} is over what is owed. keep it as credit for {client}?": "{amount} es más de lo que se debe. ¿guardarlo como crédito para {client}?",
  "payment added": "pago añadido",
  "credit added": "crédito añadido",
  "{owed} owed": "debe {owed}",
  "clients": "clientes",
  "rates": "tarifas",
  "pay": "pagar",
  "payment": "pago",
  "use credit": "usar crédito",
  "add credit": "añadir crédito",
  "owed to you": "te deben",
  "credit held": "crédito guardado",
  "add starter set": "añadir tipos básicos",
  "voice": "voz",
  "tune": "ajustar",
  "tune {name}": "ajustar {name}",
  "items shown": "elementos visibles",
  "cozy": "amplio",
  "auto": "auto",
  "whole home: spacing": "toda la portada: espaciado",
  "whole home: columns (wide screens)": "toda la portada: columnas (pantallas anchas)",
  "this browser can't listen, type here instead": "este navegador no puede escuchar, escribe aquí",
  "added to your inbox": "añadido a tu bandeja",
  "saved as {name}": "guardado como {name}",
  "sent to chi": "enviado a chi",
  "copied": "copiado",
  "open in notes": "abrir en notas",
  "no pings waiting": "no hay avisos pendientes",
  "tap the mic and talk, or type": "toca el micrófono y habla, o escribe",
  "mic blocked": "micrófono bloqueado",
  "could not hear": "no se oyó nada",
  "dictate": "dictar",
  "study": "estudiar",
  "pin": "fijar",
  "pin to home": "fijar en inicio",
  "pinned to home, press to unpin": "fijada en inicio, pulsa para quitarla",
  "pin {name} to home": "fijar {name} en inicio",
  "unpin {name} from home": "quitar {name} de inicio",
  "{count} pins is the limit, unpin one first": "el límite es de {count} notas fijadas, quita una primero",
  "Tier lists": "Listas de niveles",
  "new tier list": "nueva lista de niveles",
  "no tier lists yet. make one, add pictures and rank them": "aún no hay listas de niveles. crea una, añade imágenes y ordénalas",
  "back to my tier lists": "volver a mis listas de niveles",
  "tier list title": "título de la lista de niveles",
  "the link to this tier list": "el enlace a esta lista de niveles",
  "stop sharing": "dejar de compartir",
  "tiers": "niveles",
  "not ranked": "sin clasificar",
  "pictures not ranked yet": "imágenes aún sin clasificar",
  "add some pictures to start. drop them here, paste them, or pick them from your files": "añade imágenes para empezar. suéltalas aquí, pégalas o elígelas de tus archivos",
  "every picture is ranked": "todas las imágenes están clasificadas",
  "the picked picture": "la imagen elegida",
  "name of this picture": "nombre de esta imagen",
  "name it": "ponle nombre",
  "unrank": "quitar del nivel",
  "add tier": "añadir nivel",
  "put everything back": "devolverlo todo",
  "save picture": "guardar imagen",
  "delete list": "borrar lista",
  "tier": "nivel",
  "remove this tier": "quitar este nivel",
  "pictures in a removed tier go back to the tray": "las imágenes de un nivel quitado vuelven a la bandeja",
  "ranked": "clasificadas",
  "link on": "enlace activo",
  "could not load the tier lists": "no se pudieron cargar las listas",
  "could not make a tier list": "no se pudo crear la lista",
  "could not open that tier list": "no se pudo abrir esa lista",
  "picture": "imagen",
  "in tier {name}": "en el nivel {name}",
  "in the unranked tray": "en la bandeja sin clasificar",
  "place the picked picture in tier {name}": "poner la imagen elegida en el nivel {name}",
  "tier {name}, {count} pictures, press to change it": "nivel {name}, {count} imágenes, pulsa para cambiarlo",
  "tier {name}": "nivel {name}",
  "move tier {name} up": "subir el nivel {name}",
  "move tier {name} down": "bajar el nivel {name}",
  "tier {name} moved to row {row}": "nivel {name} movido a la fila {row}",
  "now tap a tier to place it, or drag it there": "ahora toca un nivel para colocarla, o arrástrala allí",
  "drag a picture to a tier, or tap it and then tap the tier": "arrastra una imagen a un nivel, o tócala y luego toca el nivel",
  "position {n}": "posición {n}",
  "tier removed, its pictures are back in the tray": "nivel quitado, sus imágenes volvieron a la bandeja",
  "a tier list holds {count} pictures": "una lista de niveles admite {count} imágenes",
  "those are not pictures": "eso no son imágenes",
  "adding pictures {done} of {total}": "añadiendo imágenes {done} de {total}",
  "{count} pictures added": "{count} imágenes añadidas",
  "could not add those": "no se pudieron añadir",
  "link": "enlace",
  "link is on, anyone who has it can look at this list": "el enlace está activo, quien lo tenga puede ver esta lista",
  "link is off": "el enlace está desactivado",
  "could not change the link": "no se pudo cambiar el enlace",
  "link copied": "enlace copiado",
  "press copy on your keyboard to copy the link": "usa copiar en tu teclado para copiar el enlace",
  "every picture is back in the tray": "todas las imágenes volvieron a la bandeja",
  "Music": "Música",
  "car mode": "modo coche",
  "seek": "buscar",
  "previous song": "canción anterior",
  "next song": "siguiente canción",
  "repeat off": "repetir desactivado",
  "repeat one song": "repetir una canción",
  "repeat everything": "repetir todo",
  "volume": "volumen",
  "vol": "vol",
  "library": "biblioteca",
  "songs": "canciones",
  "playlists": "listas",
  "new playlist": "nueva lista",
  "rename playlist": "renombrar lista",
  "paste a youtube link": "pega un enlace de youtube",
  "get it": "conseguirla",
  "upload mp3 or m4a files": "subir archivos mp3 o m4a",
  "youtube links are downloaded on the server into your own library. a playlist link brings every song, up to 40. files can also be dropped on this page": "los enlaces de youtube se descargan en el servidor a tu propia biblioteca. un enlace de lista trae todas las canciones, hasta 40. también puedes soltar archivos en esta página",
  "downloads": "descargas",
  "search songs": "buscar canciones",
  "back to playlists": "volver a las listas",
  "rename or delete this playlist": "renombrar o borrar esta lista",
  "song": "canción",
  "change cover": "cambiar portada",
  "remove cover": "quitar portada",
  "artist": "artista",
  "album": "álbum",
  "downloaded from youtube": "descargada de youtube",
  "delete this song": "borrar esta canción",
  "delete playlist": "borrar lista",
  "open the music player": "abrir el reproductor",
  "could not load the music": "no se pudo cargar la música",
  "nothing playing": "nada sonando",
  "unknown artist": "artista desconocido",
  "pick a song or add one": "elige una canción o añade una",
  "details for {name}": "detalles de {name}",
  "{count} songs": "{count} canciones",
  "this playlist is empty. open a song's details to add it here": "esta lista está vacía. abre los detalles de una canción para añadirla aquí",
  "no playlists yet": "aún no hay listas",
  "nothing matches that": "nada coincide",
  "no songs yet. add a youtube link or upload some files": "aún no hay canciones. añade un enlace de youtube o sube archivos",
  "could not get it": "no se pudo conseguir",
  "downloading from youtube is not set up on this server yet. uploads work. whoever runs the server needs to install yt-dlp": "la descarga de youtube aún no está configurada en este servidor. las subidas funcionan. quien administre el servidor debe instalar yt-dlp",
  "that is not a youtube link": "eso no es un enlace de youtube",
  "added to the downloads": "añadida a las descargas",
  "could not start that": "no se pudo iniciar",
  "use mp3, m4a, ogg, wav or flac files": "usa archivos mp3, m4a, ogg, wav o flac",
  "adding {done} of {total}: {name}": "añadiendo {done} de {total}: {name}",
  "could not add it": "no se pudo añadir",
  "{count} songs added": "{count} canciones añadidas",
  "added to {name}": "añadida a {name}",
  "taken out of {name}": "quitada de {name}",
  "could not change the cover": "no se pudo cambiar la portada",
  "delete the playlist {name}? the songs stay in your library": "¿borrar la lista {name}? las canciones siguen en tu biblioteca",
  "all songs": "todas las canciones",
  "shuffle everything": "todo en aleatorio",
  "could not play {name}": "no se pudo reproducir {name}",
  "leaderboard": "clasificación",
  "medals": "medallas",
  "draw today": "dibuja hoy",
  "suggestions": "sugerencias",
  "achievements": "logros",
  "points": "puntos",
  "shine": "brillo",
  "rank": "puesto",
  "ranks": "puestos",
  "exercise": "ejercicio",
  "draw a ref": "dibuja una ref",
  "another": "otro",
  "lesson": "lección",
  "other three": "otras tres",
  "done, I drew it": "listo, ya dibujé",
  "drawn today, nice": "dibujado hoy, bien",
  "no references to pick from yet": "aún no hay referencias para elegir",
  "how could chix be better?": "¿cómo podría mejorar chix?",
  "no suggestions yet, be the first": "aún no hay sugerencias, sé el primero",
  "nobody has points yet": "nadie tiene puntos todavía",
  "earn points to win your first medal": "gana puntos para ganar tu primera medalla",
  "show me on the leaderboard": "mostrarme en la clasificación",
  "of {n}": "de {n}",
  "{done} of {total} achievements": "{done} de {total} logros",
  "{n} points": "{n} puntos",
  "{n} need a polish": "{n} necesitan pulido",
  "all shining": "todas brillan",
  "needs a polish": "necesita pulido",
  "shining": "brilla",
  "keep going to find out": "sigue adelante para descubrirlo",
  "{n} min": "{n} min",
  "challenge done, {n} day streak": "reto hecho, racha de {n} días",
  "pick this reference": "elige esta referencia",
  "vote": "votar",
  "fewer": "menos",
  "planned": "planeada",
  "declined": "rechazada",
  "achievement: {name} +{points}": "logro: {name} +{points}",
  "medal earned: {name}": "medalla ganada: {name}",
  "Upskill": "Mejorar",
  "upskill": "mejorar",
  "medals gather grime every day. rub one with a finger or the mouse until it shines. a dirty medal adds less shine to your score": "las medallas se ensucian cada día. frota una con el dedo o el ratón hasta que brille. una medalla sucia suma menos brillo a tu puntuación",
  "score is points plus shine, and shine is what your medals add while they are clean": "la puntuación son los puntos más el brillo, y el brillo es lo que suman tus medallas mientras están limpias",
  "music": "música",
  "calendar": "calendario",
  "session timer": "temporizador",
  "prompt": "idea",
  "calculator": "calculadora",
  "doodle wall": "muro de garabatos",
  "whiteboards": "pizarras",
  "references": "referencias",
  "characters": "personajes",
  "tier lists": "listas de niveles",
  "gesture drawing": "dibujo gestual",
  "claude usage": "uso de claude",
  "sharing": "compartir",
  "{n} songs": "{n} canciones",
  "tap play to shuffle your library": "toca reproducir para mezclar tu biblioteca",
  "no colours saved yet": "aún no hay colores guardados",
  "no prompts saved yet": "aún no hay ideas guardadas",
  "{owed} owed to you": "te deben {owed}",
  "nobody owes you": "nadie te debe",
  "no open commissions": "no hay encargos abiertos",
  "calculate": "calcular",
  "make a wheel in spin first": "haz una ruleta en girar primero",
  "no saved places yet": "aún no hay lugares guardados",
  "no scans yet": "aún no hay escaneos",
  "the wall is empty": "el muro está vacío",
  "no whiteboards yet": "aún no hay pizarras",
  "no references yet": "aún no hay referencias",
  "no characters yet": "aún no hay personajes",
  "{ranked} of {count} ranked": "{ranked} de {count} clasificados",
  "no tier lists yet": "aún no hay listas de niveles",
  "5 × 30s": "5 × 30 s",
  "10 × 1m": "10 × 1 min",
  "20 × 2m": "20 × 2 min",
  "a warm up from the pose library, pick a length": "un calentamiento con la biblioteca de poses, elige la duración",
  "{points} points · rank {rank}": "{points} puntos · puesto {rank}",
  "nothing logged": "nada registrado",
  "of ${budget} this month": "de ${budget} este mes",
  "up": "activo",
  "nobody added yet": "nadie añadido aún",
  "{out} things shared by you, {incoming} people share with you": "{out} cosas compartidas por ti, {incoming} personas comparten contigo",
  "your medals": "tus medallas",
  "change the drawing": "cambiar el dibujo",
  "add a screenshot or photo of your drawing": "añade una captura o foto de tu dibujo",
  "your drawing": "tu dibujo",
  "a line about it (optional)": "una línea sobre él (opcional)",
  "share on the feed, +{n} points": "compartir en el feed, +{n} puntos",
  "add your drawing first": "añade tu dibujo primero",
  "finish without sharing": "terminar sin compartir",
  "you drew today and shared it, nice": "dibujaste hoy y lo compartiste, genial",
  "you can still share your drawing for +{n} points": "aún puedes compartir tu dibujo por +{n} puntos",
  "worth +{done} points, and +{more} more when you share your drawing, plus any achievement it unlocks": "vale +{done} puntos, y +{more} más si compartes tu dibujo, además de cualquier logro que desbloquee",
  "add your drawing": "añadir tu dibujo",
  "drew a reference": "dibujó una referencia",
  "drew {title}": "dibujó {title}",
  "finished draw today with a reference": "terminó dibuja hoy con una referencia",
  "finished draw today: {title}": "terminó dibuja hoy: {title}",
  "unlocked {names}": "desbloqueó {names}",
  "earned {names}": "ganó {names}",
  "finished today's cards": "terminó las tarjetas de hoy",
  "{n} answered": "{n} respondidas",
  "open the drawing": "abrir el dibujo",
  "the reference": "la referencia",
  "cheer": "ánimo",
  "drawings": "dibujos",
  "studying": "estudio",
  "my upskilling": "mi aprendizaje",
  "day streak": "racha de días",
  "answered today": "respondidas hoy",
  "start a language in upskill and it shows up here": "empieza un idioma en mejorar y aparecerá aquí",
  "{n} posts": "{n} publicaciones",
  "nothing on the feed yet, finish draw today or a day of cards": "aún no hay nada en el feed, termina dibuja hoy o un día de tarjetas",
  "nothing on the feed yet": "aún no hay nada en el feed",
  "upskilling feed": "feed de aprendizaje",
  "Draw today": "Dibuja hoy",
  "Feed": "Feed",
  "Modern Chinese": "Chino moderno",
  "Classical Chinese": "Chino clásico",
  "modern chinese words": "palabras de chino moderno",
  "classical chinese words": "palabras de chino clásico",
  "a new exercise every day, in the style of the drawabox drills and other classic warm ups. draw a ref picks three references from the shared library to choose from. drawings you share show up on the feed": "un ejercicio nuevo cada día, al estilo de los ejercicios de drawabox y otros calentamientos clásicos. dibuja una ref elige tres referencias de la biblioteca compartida. los dibujos que compartas aparecen en el feed",
  "pick a length, draw the poses, then come back here and press done": "elige una duración, dibuja las poses y vuelve aquí a pulsar listo",
  "session started today, {n} poses picked": "sesión empezada hoy, {n} poses elegidas",
  "no gesture session started today yet": "aún no has empezado una sesión gestual hoy",
  "start a gesture session first": "empieza primero una sesión gestual",
  "finished draw today with a gesture session": "terminó dibuja hoy con una sesión gestual",
  "drew {n} gesture poses": "dibujó {n} poses gestuales",
  "a new exercise every day, in the style of the drawabox drills and other classic warm ups. draw a ref picks three references from the shared library to choose from. gesture starts a timed session from the pose library. drawings you share show up on the feed": "un ejercicio nuevo cada día, al estilo de los ejercicios de drawabox y otros calentamientos clásicos. dibuja una ref elige tres referencias de la biblioteca compartida. gestual empieza una sesión cronometrada con la biblioteca de poses. los dibujos que compartas aparecen en el feed",
  "open the reference": "abrir la referencia",
  "don't draw this one": "no dibujar esta",
  "draw this one": "dibujar esta",
  "picked": "elegida",
  "pick": "elegir",
  "favorite": "favorita",
  "favorites": "favoritas",
  "to do": "por hacer",
  "doing": "en curso",
  "blocked": "bloqueada",
  "move to": "mover a",
  "status: {status}": "estado: {status}",
  "hidden here, still open in plane": "oculta aquí, sigue abierta en plane",
  "sure?": "¿seguro?",
  "delete task": "borrar tarea",
  "hide task": "ocultar tarea",
  "hide the hidden": "ocultar las ocultas",
  "show hidden ({count})": "mostrar ocultas ({count})",
  "restore": "restaurar",
  "nothing here": "nada aquí",
  "trash": "papelera",
  "tap the trash can on the card to delete it": "toca la papelera de la tarjeta para borrarla",
  "set status": "cambiar estado",
  "note (optional)": "nota (opcional)",
  "Linked calendars": "Calendarios vinculados",
  "Chi copies these in read only, one way. Changes made here never go back to them.": "Chi los copia solo de lectura, en un sentido. Los cambios hechos aquí nunca vuelven a ellos.",
  "Name": "Nombre",
  "Calendar link": "Enlace del calendario",
  "Add calendar": "Añadir calendario",
  "Adding": "Añadiendo",
  "Proton: Settings, Calendars, Share via link (private). Google: Settings, your calendar, Secret address in iCal format. Apple: Calendar, share, Public calendar, copy link. Outlook: Settings, Shared calendars, Publish a calendar, ICS. Nextcloud: calendar menu, Copy private link.": "Proton: Ajustes, Calendarios, Compartir mediante enlace (privado). Google: Ajustes, tu calendario, Dirección secreta en formato iCal. Apple: Calendario, compartir, Calendario público, copiar enlace. Outlook: Configuración, Calendarios compartidos, Publicar un calendario, ICS. Nextcloud: menú del calendario, Copiar enlace privado.",
  "Let Chi see this calendar": "Dejar que Chi vea este calendario",
  "Sync now": "Sincronizar ahora",
  "Syncing": "Sincronizando",
  "Remove": "Quitar",
  "Tap again to remove": "Toca otra vez para quitar",
  "never synced": "sin sincronizar",
  "{count} min ago": "hace {count} min",
  "{count} h ago": "hace {count} h",
  "{count} d ago": "hace {count} d",
  "synced {when} · {count} events": "sincronizado {when} · {count} eventos",
  "last good sync {when}": "última sincronización correcta {when}",
  "could not sync": "no se pudo sincronizar",
  "could not add that calendar": "no se pudo añadir ese calendario",
  "that does not look like a calendar link": "eso no parece un enlace de calendario",
  "calendar links must start with https:// or webcal://": "los enlaces deben empezar con https:// o webcal://",
  "that link has a login inside it, use the private share link instead": "ese enlace lleva un usuario dentro, usa el enlace privado para compartir",
  "that address is not allowed": "esa dirección no está permitida",
  "that calendar is too big (over 5 MB)": "ese calendario es demasiado grande (más de 5 MB)",
  "that link did not give a calendar file": "ese enlace no dio un archivo de calendario",
  "the calendar server took too long": "el servidor del calendario tardó demasiado",
  "could not reach that calendar": "no se pudo llegar a ese calendario",
  "that calendar is already linked": "ese calendario ya está vinculado",
  "that is plenty of linked calendars, remove one first": "ya son muchos calendarios vinculados, quita uno primero",
  "too many redirects": "demasiadas redirecciones",
  "the calendar server sent a broken redirect": "el servidor del calendario envió una redirección rota",
  "otherworld rust": "óxido del otro mundo",
  "hospital green": "verde hospital",
  "y2k aqua": "aqua y2k",
  "vhs blue": "azul vhs",
  "paper zine": "zine de papel",
  "cassette": "casete",
  "moonlit violet": "violeta lunar",
  "lime soda": "soda de lima",
  "rose quartz": "cuarzo rosa",
  "sepia archive": "archivo sepia",
  "deep sea lab": "laboratorio abisal",
  "arcade night": "noche arcade",
  "velvet room": "sala de terciopelo",
  "boudoir": "tocador",
  "latex noir": "látex noir",
  "neon lounge": "salón neón",
  "succubus": "súcubo",
  "honey trap": "trampa de miel",
  "cherry cola": "cola de cereza",
  "after hours": "fuera de horas",
  "peeling paint and a rusted siren": "pintura descascarada y una sirena oxidada",
  "flickering corridor light, sick green tile": "luz de pasillo parpadeante, azulejo verde enfermizo",
  "glossy bubble blue, 2001 desktop": "azul burbuja brillante, escritorio de 2001",
  "tracking lines and a blue no signal screen": "líneas de tracking y una pantalla azul sin señal",
  "photocopied paper and red marker": "papel fotocopiado y rotulador rojo",
  "walkman amber, warm brown tape": "ámbar de walkman, cinta marrón cálida",
  "a quiet night in lavender light": "una noche tranquila con luz lavanda",
  "fizzy lime, bright sticker shop": "lima burbujeante, tienda de pegatinas",
  "pale pink stone and soft rose": "piedra rosa pálida y rosa suave",
  "old film stock and brown ink": "película antigua y tinta marrón",
  "bathyscaphe lights and bioluminescent teal": "luces de batiscafo y verde azulado bioluminiscente",
  "cabinet glow, hot pink and electric cyan": "brillo de recreativa, rosa fuerte y cian eléctrico",
  "wine velvet curtains and low red light": "cortinas de terciopelo vino y luz roja tenue",
  "dusty rose, silk and brass lamplight": "rosa empolvado, seda y luz de lámpara de latón",
  "wet black gloss and a red sliver": "negro brillante mojado y una rendija roja",
  "magenta tubes in a smoky bar": "tubos magenta en un bar con humo",
  "blood red, violet shadow, a wicked grin": "rojo sangre, sombra violeta, una sonrisa pícara",
  "warm amber, sticky gold and candle smoke": "ámbar cálido, oro pegajoso y humo de vela",
  "dark fizz, cherry red, diner neon": "burbujas oscuras, rojo cereza, neón de cafetería",
  "midnight indigo and rose city lights": "índigo de medianoche y luces rosadas de la ciudad",
  "otherworld": "otro mundo",
  "y2k": "y2k",
  "mature": "adulto",
  "basic": "básico",
  "japanese": "japonés",
  "horror": "terror",
  "Silkscreen titles over the pixel labels": "títulos en Silkscreen sobre las etiquetas de píxeles",
  "Pixelify Sans, a chunky bitmap face": "Pixelify Sans, una fuente de mapa de bits robusta",
  "Share Tech Mono, a thin hud readout": "Share Tech Mono, una lectura fina de hud",
  "IBM Plex Mono, a tidy code face": "IBM Plex Mono, una fuente de código ordenada",
  "Major Mono Display titles, text in Space Mono": "títulos en Major Mono Display, texto en Space Mono",
  "Audiowide titles over the original labels": "títulos en Audiowide sobre las etiquetas originales",
  "Chakra Petch, angular and techy": "Chakra Petch, angular y tecnológica",
  "Unbounded titles, Lexend text": "títulos en Unbounded, texto en Lexend",
  "Syne, wide and art gallery edgy": "Syne, ancha y de galería de arte",
  "Monoton titles, a neon sign outline": "títulos en Monoton, contorno de letrero de neón",
  "Bungee titles, shop sign letters": "títulos en Bungee, letras de rótulo de tienda",
  "Righteous titles, a 70s poster face": "títulos en Righteous, fuente de cartel de los 70",
  "Bebas Neue titles, tall and flat": "títulos en Bebas Neue, altos y planos",
  "Pacifico titles, a surf shop script": "títulos en Pacifico, letra de tienda de surf",
  "Fraunces, a soft old style serif": "Fraunces, una serif suave de estilo antiguo",
  "Playfair Display, high contrast and elegant": "Playfair Display, alto contraste y elegante",
  "Cormorant Garamond, a delicate book face": "Cormorant Garamond, una fuente de libro delicada",
  "Cinzel titles, carved roman capitals": "títulos en Cinzel, capitales romanas talladas",
  "Permanent Marker titles, Gloria Hallelujah text": "títulos en Permanent Marker, texto en Gloria Hallelujah",
  "Kalam, quick pen handwriting": "Kalam, escritura rápida a pluma",
  "Dancing Script titles, Kalam text": "títulos en Dancing Script, texto en Kalam",
  "Indie Flower, loopy and cheerful": "Indie Flower, redondeada y alegre",
  "Shadows Into Light, thin felt tip": "Shadows Into Light, rotulador fino",
  "Nunito, rounded and calm": "Nunito, redondeada y tranquila",
  "Quicksand, light and round": "Quicksand, ligera y redonda",
  "Comfortaa, circles and soft curves": "Comfortaa, círculos y curvas suaves",
  "Baloo 2, plump and friendly": "Baloo 2, regordeta y amigable",
  "Lexend, wide open and easy to read": "Lexend, abierta y fácil de leer",
  "Josefin Sans, vintage geometric": "Josefin Sans, geométrica vintage",
  "Zen Maru Gothic, round gothic": "Zen Maru Gothic, gótica redonda",
  "Yusei Magic, felt pen marker": "Yusei Magic, rotulador de fieltro",
  "Hachi Maru Pop, bubbly pop lettering": "Hachi Maru Pop, letras pop burbujeantes",
  "Reggae One titles, heavy and loud": "títulos en Reggae One, pesados y llamativos",
  "Creepster titles, dripping horror": "títulos en Creepster, terror goteante",
  "Rubik Glitch titles, a broken signal": "títulos en Rubik Glitch, una señal rota",
  "panels and screen": "paneles y pantalla",
  "cursor": "cursor",
  "panel style": "estilo de panel",
  "screen filter": "filtro de pantalla",
  "mouse cursor": "cursor del ratón",
  "cursor pack": "paquete de cursor",
  "filter strength": "fuerza del filtro",
  "adult themes and cursors": "temas y cursores para adultos",
  "Adult themes and cursors, suggestive but never explicit. Off by default. Only affects your own screen.": "Temas y cursores para adultos, sugerentes pero nunca explícitos. Desactivado por defecto. Solo afecta a tu propia pantalla.",
  "adult options on": "opciones para adultos activadas",
  "adult options off": "opciones para adultos desactivadas",
  "bracket": "corchetes",
  "double line": "doble línea",
  "window": "ventana",
  "offset": "desplazado",
  "stitched": "cosido",
  "no frame": "sin marco",
  "night vision": "visión nocturna",
  "dream": "sueño",
  "grayscale": "escala de grises",
  "commission": "comisión",
  "delete commission": "borrar comisión",
  "Shared with me ({count})": "Compartido conmigo ({count})",
  "sponge": "esponja",
  "cloth": "paño",
  "locked": "bloqueada",
  "condition": "estado",
  "holo": "holo",
  "Special": "Especial",
  "Rusty": "Oxidada",
  "Tarnished": "Deslucida",
  "Dull": "Opaca",
  "Clean": "Limpia",
  "Mirror": "Espejo",
  "The Collection": "La colección",
  "{n} of {total}": "{n} de {total}",
  "needs polish": "necesita pulido",
  "fully polished": "pulida del todo",
  "a medal you have not found yet": "una medalla que aún no has encontrado",
  "Put back in the case": "Volver a la vitrina",
  "take the {tool}": "coger {tool}",
  "scrape off the rust": "raspa el óxido",
  "scrub off the grime": "frota la mugre",
  "polish it to a shine": "púlela hasta que brille",
  "That is rust. Scrape it off with the brush first.": "Eso es óxido. Primero rásbalo con el pincel.",
  "That is grime. Scrub it off with the sponge first.": "Eso es mugre. Primero frótala con la esponja.",
  "Nothing left for the {tool}. Try the {next}.": "No queda nada para {tool}. Prueba {next}.",
  "Rub the medal with the {tool}. Press space to scrub.": "Frota la medalla con {tool}. Pulsa espacio para frotar.",
  "every area of chix has its own shelf. tap a medal to take it to the workbench and clean it with the brush, the sponge and the cloth. a dirty medal adds less shine to your score": "cada zona de chix tiene su propio estante. toca una medalla para llevarla al banco de trabajo y límpiala con el pincel, la esponja y el paño. una medalla sucia suma menos brillo a tu puntuación",
  "{count} new medals": "{count} medallas nuevas",
  "Earned for": "Ganada por",
  "How to earn it": "Cómo conseguirla",
  "Date": "Fecha",
  "Not earned yet": "Aún no conseguida",
  "{n} {area} points": "{n} puntos de {area}",
  "Close": "Cerrar",
  "{n} medals": "{n} medallas",
  "{n} shining": "{n} brillantes",
  "{n} rusty": "{n} oxidadas",
  "Bronze": "Bronce",
  "Silver": "Plata",
  "Gold": "Oro",
  "Crystal": "Cristal",
  "Money": "Dinero",
  "Menu": "Menú",
  "menu": "menú",
  "stations": "estaciones",
  "go to…": "ir a…",
  "places in {name}": "lugares en {name}",
  "{count} places": "{count} lugares",
  "search every place": "buscar en todo",
  "skip to content": "saltar al contenido",
  "wall": "muro",
  "boards": "pizarras",
  "moodboard": "moodboard",
  "ref feed": "feed de refs",
  "today at a glance": "el día de un vistazo",
  "what to do and when": "qué hacer y cuándo",
  "make art, keep your world": "crea arte, cuida tu mundo",
  "get better every day": "mejora cada día",
  "commissions and budget": "encargos y presupuesto",
  "small handy things": "pequeñas utilidades",
  "run the app": "gestiona la app",
  "station tuner. tap for all stations, drag to tune, arrow keys to step": "sintonizador de estaciones. toca para ver todas, arrastra para sintonizar, flechas para avanzar",
  "show tasks from": "mostrar tareas de",
  "plane tasks": "tareas de plane",
  "chix bot tasks": "tareas del bot chix",
  "commission tasks": "tareas de encargos",
  "on chosen weekdays": "en días elegidos",
  "a few times a week": "unas veces por semana",
  "when": "cuándo",
  "just once": "solo una vez",
  "every week": "cada semana",
  "type": "tipo",
  "blend mode": "modo de fusión",
  "darkening": "oscurecer",
  "lightening": "aclarar",
  "compare": "comparar",
  "what to be pinged about": "de qué avisarte",
  "routine name": "nombre de la rutina",
  "note title": "título de la nota",
  "note body": "texto de la nota",
  "task name": "nombre de la tarea",
  "event title": "título del evento",
  "piece name": "nombre de la pieza",
  "client": "cliente",
  "price": "precio",
  "images": "imágenes",
  "audio files": "archivos de audio",
  "cover image": "portada",
  "joined Chi. say hi!": "se unió a Chi. ¡Saluda!",
  "started a shared whiteboard: {title}": "empezó una pizarra compartida: {title}",
  "made a tier list public: {title}": "hizo pública una tier list: {title}",
  "joined": "nuevo",
  "medal": "medalla",
  "art": "arte",
  "open the picture": "abrir la imagen",
  "comments": "comentarios",
  "comment": "comentar",
  "write a comment": "escribe un comentario",
  "edit post": "editar publicación",
  "delete your post? it goes for everyone": "¿borrar tu publicación? desaparece para todos",
  "delete {name}'s post? it goes for everyone": "¿borrar la publicación de {name}? desaparece para todos",
  "posts": "publicaciones",
  "events": "eventos",
  "feed": "novedades",
  "nothing on the feed yet. post the first one": "aún no hay nada. publica lo primero",
  "post to the feed": "publicar en las novedades",
  "write a post": "escribe una publicación",
  "post": "publicar",
  "couldn't open that picture": "no se pudo abrir esa imagen",
  "a picture needs to be a png, jpeg, webp or gif": "la imagen debe ser png, jpeg, webp o gif",
  "that post is gone": "esa publicación ya no existe",
  "you can only edit your own posts": "solo puedes editar tus publicaciones",
  "that isn't yours to remove": "eso no es tuyo para quitarlo",
  "this post has enough comments": "esta publicación ya tiene suficientes comentarios",
  "couldn't remove that": "no se pudo quitar",
  "board name": "nombre del tablero",
  "sure? tap again": "¿seguro? toca otra vez",
  "{name}, plane project": "{name}, proyecto de plane",
  "rename or delete {name}": "renombrar o borrar {name}",
  "{count} tasks on this board. Deleting the board moves them to {inbox}.": "{count} tareas en este tablero. Al borrarlo pasan a {inbox}.",
  "board deleted, its tasks are back in {inbox}": "tablero borrado, sus tareas volvieron a {inbox}"
};
